import React, { useState, useEffect } from "react";

// --- TAILWIND INJECTION FOR UNCONFIGURED ENVIRONMENTS ---
if (typeof window !== "undefined" && typeof document !== "undefined") {
  if (!document.getElementById("tailwind-cdn")) {
    const script = document.createElement("script");
    script.id = "tailwind-cdn";
    script.src = "https://cdn.tailwindcss.com";
    document.head.appendChild(script);
  }
}

// --- INLINE ICONS ---
const createIcon =
  (paths: any) =>
  ({ size = 24, className = "", fill = "none", onClick, ...rest }: any) =>
    (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={fill}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        onClick={onClick}
        {...rest}
      >
        {paths}
      </svg>
    );

const Home = createIcon(
  <g>
    <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </g>
);
const Calendar = createIcon(
  <g>
    <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
    <line x1="16" x2="16" y1="2" y2="6" />
    <line x1="8" x2="8" y1="2" y2="6" />
    <line x1="3" x2="21" y1="10" y2="10" />
  </g>
);
const Users = createIcon(
  <g>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </g>
);
const Radio = createIcon(
  <g>
    <circle cx="12" cy="12" r="2" />
    <path d="M4.93 10.93a10 10 0 0 1 14.14 0" />
    <path d="M2 14c0-5.52 4.48-10 10-10s10 4.48 10 10" />
    <path d="M8.46 14.46a5 5 0 0 1 7.08 0" />
  </g>
);
const Tv = createIcon(
  <g>
    <rect width="20" height="15" x="2" y="7" rx="2" ry="2" />
    <polyline points="17 2 12 7 7 2" />
  </g>
);
const Shirt = createIcon(
  <path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z" />
);
const Music = createIcon(
  <g>
    <path d="M9 18V5l12-2v13" />
    <circle cx="6" cy="18" r="3" />
    <circle cx="18" cy="16" r="3" />
  </g>
);
const Newspaper = createIcon(
  <g>
    <path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2" />
    <path d="M18 14h-8" />
    <path d="M15 18h-5" />
    <path d="M10 6h8v4h-8V6Z" />
  </g>
);
const Trophy = createIcon(
  <g>
    <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
    <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
    <path d="M4 22h16" />
    <path d="M10 14.66V17c0 1.1-.9 2-2 2H6" />
    <path d="M14 14.66V17c0 1.1.9 2 2 2h2" />
    <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
  </g>
);
const MapPin = createIcon(
  <g>
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </g>
);
const PlayCircle = createIcon(
  <g>
    <circle cx="12" cy="12" r="10" />
    <polygon points="10 8 16 12 10 16 10 8" />
  </g>
);
const Youtube = createIcon(
  <g>
    <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17" />
    <path d="m10 15 5-3-5-3z" />
  </g>
);
const Sun = createIcon(
  <g>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2" />
    <path d="M12 20v2" />
    <path d="m4.93 4.93 1.41 1.41" />
    <path d="m17.66 17.66 1.41 1.41" />
    <path d="M2 12h2" />
    <path d="M20 12h2" />
    <path d="m6.34 17.66-1.41 1.41" />
    <path d="m19.07 4.93-1.41 1.41" />
  </g>
);
const BookOpen = createIcon(
  <g>
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
  </g>
);
const ChevronLeft = createIcon(<path d="m15 18-6-6 6-6" />);
const ChevronRight = createIcon(<path d="m9 18 6-6-6-6" />);
const ChevronDown = createIcon(<path d="m6 9 6 6 6-6" />);
const ChevronUp = createIcon(<path d="m18 15-6-6-6 6" />);
const Play = createIcon(<polygon points="6 3 20 12 6 21 6 3" />);
const X = createIcon(
  <g>
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </g>
);
const Palette = createIcon(
  <g>
    <circle cx="13.5" cy="6.5" r=".5" fill="currentColor" />
    <circle cx="17.5" cy="10.5" r=".5" fill="currentColor" />
    <circle cx="8.5" cy="7.5" r=".5" fill="currentColor" />
    <circle cx="6.5" cy="12.5" r=".5" fill="currentColor" />
    <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" />
  </g>
);
const Search = createIcon(
  <g>
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.3-4.3" />
  </g>
);

const VINTAGE_ARTICLES = [
  {
    id: 1,
    headline: "AMAZIN'! METS WIN IT ALL",
    date: "October 17, 1969",
    publication: "The New York Daily News",
    snippet:
      "The Miracle Mets have done the impossible. In a stunning upset, the New York Mets defeated the heavily favored Baltimore Orioles...",
    link: "https://en.wikipedia.org/wiki/1969_World_Series",
  },
  {
    id: 2,
    headline: "IT GETS BY BUCKNER!",
    date: "October 25, 1986",
    publication: "Newsday",
    snippet:
      "Mookie Wilson's slow roller trickled through the legs of Bill Buckner, capping a miraculous 3-run rally in the bottom of the 10th inning...",
    link: "https://en.wikipedia.org/wiki/1986_World_Series",
  },
  {
    id: 3,
    headline: "PIAZZA LIFTS NEW YORK",
    date: "September 21, 2001",
    publication: "The New York Times",
    snippet:
      "In the first sporting event in the city since the attacks, Mike Piazza hit a dramatic 8th-inning home run to lift the city's spirits...",
    link: "https://en.wikipedia.org/wiki/Mike_Piazza",
  },
];

// --- ADVANCED THEME ENGINE ---
const THEMES: any = {
  "1969": {
    name: "1969 Miracle",
    primary: "#002D72",
    secondary: "#FF5910",
    bg: "#E5E0D8",
    bgAlt: "#F5F2EB",
    card: "#FCFAF5",
    text: "#002D72",
    textMuted: "#4B5563",
    textPrimary: "#002D72",
    borderPrimary: "#002D72",
    fontHead: "Georgia, 'Times New Roman', serif",
    pinstripes:
      "repeating-linear-gradient(to right, transparent, transparent 18px, rgba(0, 45, 114, 0.15) 18px, rgba(0, 45, 114, 0.15) 20px)",
  },
  "1986": {
    name: "1986 Racing Stripes",
    primary: "#0038A8",
    secondary: "#FF4500",
    bg: "#E2E8F0",
    bgAlt: "#F8FAFC",
    card: "#FFFFFF",
    text: "#0F172A",
    textMuted: "#475569",
    textPrimary: "#0038A8",
    borderPrimary: "#0038A8",
    fontHead: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    pinstripes:
      "linear-gradient(90deg, rgba(0,56,168,0.15) 0px, rgba(0,56,168,0.15) 6px, rgba(255,69,0,0.15) 6px, rgba(255,69,0,0.15) 12px, transparent 12px, transparent calc(100% - 12px), rgba(255,69,0,0.15) calc(100% - 12px), rgba(255,69,0,0.15) calc(100% - 6px), rgba(0,56,168,0.15) calc(100% - 6px), rgba(0,56,168,0.15) 100%)",
  },
  "2000s": {
    name: "2000s Blackout",
    primary: "#000000",
    secondary: "#FF5910",
    bg: "#111827",
    bgAlt: "#030712",
    card: "#1F2937",
    text: "#F8FAFC",
    textMuted: "#9CA3AF",
    textPrimary: "#FFFFFF",
    borderPrimary: "#4B5563",
    fontHead: "'Arial Black', 'Segoe UI Black', sans-serif",
    pinstripes: "none",
  },
  CityConnect: {
    name: "City Connect",
    primary: "#1C1C1C",
    secondary: "#B57EDC",
    bg: "#2D2D2D",
    bgAlt: "#1C1C1C",
    card: "#3A3A3A",
    text: "#F3F4F6",
    textMuted: "#9CA3AF",
    textPrimary: "#E9D5FF",
    borderPrimary: "#B57EDC",
    fontHead:
      "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    pinstripes:
      "repeating-linear-gradient(45deg, rgba(181, 126, 220, 0.08) 0, rgba(181, 126, 220, 0.08) 2px, transparent 2px, transparent 16px), repeating-linear-gradient(-45deg, rgba(181, 126, 220, 0.08) 0, rgba(181, 126, 220, 0.08) 2px, transparent 2px, transparent 16px)",
  },
};

const cardStyle =
  "bg-theme-card border-2 border-theme-primary shadow-theme-primary mb-4 text-theme-text";
const innerBorderStyle = "border-t-2 border-theme-primary";
const labelStyle =
  "text-[10px] font-black text-theme-primary uppercase tracking-widest";

// --- HELPERS ---
const predictMetsUniform = (dateString: string, isHome: boolean) => {
  const dayOfWeek = new Date(dateString).getDay();
  if (isHome) {
    if (dayOfWeek === 5) return "Friday Black Alternate";
    if (dayOfWeek === 6) return "City Connect (Concrete/Purple)";
    if (dayOfWeek === 0) return "Sunday Home Blue";
    return "Home Pinstripes";
  } else {
    if (dayOfWeek === 5 || dayOfWeek === 0) return "Road Blue Alternate";
    return "Road Grey";
  }
};

// --- COMPONENTS ---
const TabButton = ({ icon, label, isActive, onClick, isScrolled }: any) => {
  return (
    <button
      onClick={onClick}
      className={`flex flex-col items-center justify-center transition-all duration-300 relative z-10 text-theme-primary ${
        isActive ? "" : "opacity-60 hover:opacity-100"
      } ${isScrolled ? "w-14 mt-1" : "w-16 mt-2"}`}
    >
      <div
        className={`transition-all duration-300 transform ${
          isActive ? "drop-shadow-theme-text" : ""
        } ${
          isScrolled
            ? isActive
              ? "scale-90 mb-0.5"
              : "scale-75 mb-0.5"
            : isActive
            ? "scale-110 mb-1"
            : "scale-100 mb-1"
        }`}
      >
        {icon}
      </div>
      <span
        className={`tracking-widest font-sans uppercase transition-all duration-300 transform origin-top ${
          isActive ? "font-black" : "font-bold"
        } ${isScrolled ? "scale-75" : "scale-100"} text-[9px]`}
      >
        {label}
      </span>
    </button>
  );
};

const PillButton = ({ label, isActive, onClick }: any) => {
  return (
    <button
      onClick={onClick}
      className={`px-3 py-1.5 text-[9px] sm:text-[10px] font-sans tracking-widest uppercase font-black transition-colors duration-200 whitespace-nowrap border-2 ${
        isActive
          ? "bg-theme-secondary text-white border-theme-secondary shadow-[inset_0_-2px_0_rgba(0,0,0,0.2)]"
          : "bg-theme-card text-theme-primary border-theme-primary hover:bg-theme-bg"
      }`}
    >
      {label}
    </button>
  );
};

const StatBox = ({ label, value }: { label: string; value: any }) => {
  const displayValue =
    value !== null && value !== undefined && value !== "" ? String(value) : "-";
  return (
    <div className="bg-theme-bg-alt border border-theme-primary/30 p-2 flex flex-col items-center justify-center shadow-[1px_1px_0_0_var(--c-primary)] hover:bg-theme-bg transition-colors">
      <span className="text-[9px] font-sans font-bold text-theme-muted uppercase tracking-widest leading-none mb-1">
        {label}
      </span>
      <span className="font-mono font-black text-theme-primary text-sm leading-none">
        {displayValue}
      </span>
    </div>
  );
};

const JerseyGraphic = ({
  name,
  size = 48,
}: {
  name: string;
  size?: number;
}) => {
  let mainColor = "#FCFAF5",
    trimColor = "#002D72",
    hasPinstripes = false,
    text = "Mets",
    textColor = "#002D72",
    shadowColor = "#FF5910";
  const lowerName = String(name || "").toLowerCase();

  if (lowerName.includes("black")) {
    mainColor = "#111827";
    trimColor = "#FF5910";
    text = "Mets";
    textColor = "#002D72";
    shadowColor = "#FFFFFF";
  } else if (lowerName.includes("city connect")) {
    mainColor = "#2D2D2D";
    trimColor = "#B57EDC";
    text = "NYC";
    textColor = "#2D2D2D";
    shadowColor = "#B57EDC";
  } else if (lowerName.includes("road blue")) {
    mainColor = "#002D72";
    trimColor = "#D1D5DB";
    text = "NEW YORK";
    textColor = "#D1D5DB";
    shadowColor = "#FF5910";
  } else if (lowerName.includes("blue")) {
    mainColor = "#002D72";
    trimColor = "#FF5910";
    text = "Mets";
    textColor = "#FF5910";
    shadowColor = "#FFFFFF";
  } else if (lowerName.includes("grey") || lowerName.includes("road")) {
    mainColor = "#D1D5DB";
    trimColor = "#002D72";
    text = "NEW YORK";
    textColor = "#002D72";
    shadowColor = "#FF5910";
  } else if (lowerName.includes("pinstripes") || lowerName.includes("home")) {
    hasPinstripes = true;
  }

  return (
    <div
      className="relative flex-shrink-0"
      style={{ width: size, height: size }}
    >
      <svg
        viewBox="0 0 100 100"
        className="w-full h-full drop-shadow-sm overflow-visible"
      >
        <path
          d="M20 20 L40 5 L60 5 L80 20 L95 40 L85 55 L75 50 L75 95 L25 95 L25 50 L15 55 L5 40 Z"
          fill={mainColor}
          stroke={trimColor}
          strokeWidth="3"
        />
        {hasPinstripes && (
          <g>
            <defs>
              <clipPath id="jerseyClip">
                <path d="M20 20 L40 5 L60 5 L80 20 L95 40 L85 55 L75 50 L75 95 L25 95 L25 50 L15 55 L5 40 Z" />
              </clipPath>
            </defs>
            <g clipPath="url(#jerseyClip)">
              {Array.from({ length: 10 }).map((_, i) => (
                <line
                  key={`pin-${i}`}
                  x1={i * 10}
                  y1="0"
                  x2={i * 10}
                  y2="100"
                  stroke={trimColor}
                  strokeWidth="1"
                  opacity="0.4"
                />
              ))}
            </g>
          </g>
        )}
        <line
          x1="50"
          y1="5"
          x2="50"
          y2="95"
          stroke={trimColor}
          strokeWidth="1.5"
          opacity="0.3"
        />
        <text
          x="50"
          y="50"
          textAnchor="middle"
          fill={textColor}
          style={{
            fontSize: text === "Mets" || text === "NYC" ? "18px" : "12px",
            fontWeight: "900",
            fontStyle: "italic",
            fontFamily: "var(--f-head)",
            filter: `drop-shadow(1px 1px 0px ${shadowColor})`,
          }}
          transform="rotate(-10, 50, 50)"
        >
          {text}
        </text>
      </svg>
    </div>
  );
};

const UniformSwatch = ({ name }: { name: string }) => {
  return (
    <div className="mt-3 pt-3 border-t-2 border-dashed border-theme-primary/30 flex items-center justify-between opacity-80 hover:opacity-100 transition-opacity">
      <span className="text-[8px] font-sans font-black text-theme-muted uppercase tracking-widest flex items-center">
        <Shirt size={10} className="mr-1.5 text-theme-secondary" />
        Uniform Watch
      </span>
      <div className="flex items-center space-x-2">
        <span className="font-bold font-sans text-[9px] text-theme-primary uppercase tracking-wider">
          {name}
        </span>
        <JerseyGraphic name={name} size={20} />
      </div>
    </div>
  );
};

const StreetSignLogo = ({ isScrolled }: { isScrolled: boolean }) => {
  return (
    <div
      className={`transition-all duration-300 origin-left transform ${
        isScrolled
          ? "scale-[0.80] -rotate-2 -translate-y-1"
          : "scale-100 -rotate-2 mt-2"
      }`}
    >
      <div className="relative inline-flex flex-col items-center justify-center bg-theme-primary border-[3px] border-theme-secondary rounded shadow-theme-secondary px-4 py-1.5">
        <div className="absolute inset-[2px] border border-white/50 rounded-[1px] pointer-events-none"></div>
        <div className="flex items-baseline space-x-1.5">
          <span className="text-white font-black font-sans tracking-tighter leading-none relative z-10 whitespace-nowrap text-2xl">
            METROPOLITANS
          </span>
          <span className="text-white font-bold font-sans uppercase leading-none relative z-10 text-[10px] mb-[2px]">
            Ave
          </span>
        </div>
      </div>
    </div>
  );
};

const TeamBoxTable = ({
  teamData,
  onPlayerClick,
}: {
  teamData: any;
  onPlayerClick: any;
}) => {
  if (!teamData || !teamData.batters) return null;
  return (
    <div className="animate-in fade-in duration-200 space-y-3">
      <table className="w-full text-center text-[9px] font-mono border-2 border-theme-primary bg-theme-card shadow-[2px_2px_0_0_var(--c-border-primary)]">
        <thead className="bg-theme-primary text-white uppercase tracking-widest font-sans">
          <tr>
            <th className="p-1 pl-2 text-left">Batter</th>
            <th className="p-1">AB</th>
            <th className="p-1">R</th>
            <th className="p-1">H</th>
            <th className="p-1">RBI</th>
            <th className="p-1">BB</th>
            <th className="p-1">SO</th>
          </tr>
        </thead>
        <tbody className="text-theme-text font-bold">
          {teamData.batters.map((b: any, i: number) => (
            <tr
              key={`b-${i}`}
              className="border-b border-dotted border-theme-primary/30 last:border-0 hover:bg-theme-bg"
            >
              <td className="p-1 pl-2 text-left truncate max-w-[80px]">
                <span
                  className="uppercase text-theme-primary font-black font-sans cursor-pointer hover:text-theme-secondary hover:underline transition-colors"
                  onClick={() => onPlayerClick(b.name)}
                >
                  {b.name}
                </span>{" "}
                <span className="text-[8px] text-theme-muted font-sans">
                  {b.pos}
                </span>
              </td>
              <td className="p-1">{String(b.ab)}</td>
              <td className="p-1">{String(b.r)}</td>
              <td className="p-1">{String(b.h)}</td>
              <td className="p-1">{String(b.rbi)}</td>
              <td className="p-1">{String(b.bb)}</td>
              <td className="p-1">{String(b.so)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const PitchingDetails = ({
  boxScore,
  awayName,
  homeName,
  onPlayerClick,
}: any) => {
  if (!boxScore || !boxScore.away || !boxScore.home) return null;

  const renderPitchingTable = (team: any, teamName: string) => (
    <div className="mb-3 last:mb-0 border-2 border-theme-primary shadow-[2px_2px_0_0_var(--c-border-primary)] bg-theme-card">
      <div className="bg-theme-bg-alt p-1.5 pl-2 text-theme-primary border-b-2 border-theme-primary uppercase tracking-widest font-sans font-bold text-[9px]">
        {teamName} Pitching
      </div>
      <table className="w-full text-center text-[9px] font-mono">
        <thead className="text-theme-muted uppercase tracking-widest font-sans border-b border-dotted border-theme-primary/30">
          <tr>
            <th className="p-1 pl-2 text-left font-bold">Pitcher</th>
            <th className="p-1 font-bold">IP</th>
            <th className="p-1 font-bold">H</th>
            <th className="p-1 font-bold">R</th>
            <th className="p-1 font-bold">ER</th>
            <th className="p-1 font-bold">BB</th>
            <th className="p-1 font-bold">K</th>
            <th className="p-1 font-bold">HR</th>
            <th className="p-1 font-bold">P-S</th>
          </tr>
        </thead>
        <tbody className="text-theme-text font-bold">
          {team.pitchers.map((p: any, i: number) => (
            <tr
              key={`p-${i}`}
              className="border-b border-dotted border-theme-primary/20 last:border-0 hover:bg-theme-bg transition-colors"
            >
              <td className="p-1 pl-2 text-left truncate max-w-[70px] sm:max-w-[100px]">
                <span
                  className="uppercase text-theme-primary font-black font-sans cursor-pointer hover:text-theme-secondary hover:underline transition-colors"
                  onClick={() => onPlayerClick(p.name)}
                >
                  {p.name}
                </span>
              </td>
              <td className="p-1">{String(p.ip)}</td>
              <td className="p-1">{String(p.h)}</td>
              <td className="p-1">{String(p.r)}</td>
              <td className="p-1">{String(p.er)}</td>
              <td className="p-1">{String(p.bb)}</td>
              <td className="p-1">{String(p.so)}</td>
              <td className="p-1">{String(p.hr)}</td>
              <td className="p-1 text-theme-muted">
                {p.pitches}-{p.strikes}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="mb-4 animate-in fade-in duration-200">
      <h4 className={labelStyle + " mb-2 flex items-center"}>
        <Users size={12} className="mr-1.5 text-theme-secondary" /> Pitching
        Stats
      </h4>
      {renderPitchingTable(boxScore.away, awayName)}
      {renderPitchingTable(boxScore.home, homeName)}
    </div>
  );
};

const BoxScoreView = ({
  gameData,
  boxTab,
  setBoxTab,
  awayName,
  homeName,
  onPlayerClick,
}: any) => {
  if (!gameData || !gameData.boxScore) return null;
  return (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-2">
        <h4 className={labelStyle + " flex items-center"}>
          <Users size={12} className="mr-1.5 text-theme-secondary" /> Box Score
        </h4>
        <div className="flex space-x-1">
          <button
            onClick={() => setBoxTab("away")}
            className={`text-[8px] font-black tracking-widest uppercase px-2 py-1 border border-theme-primary transition-colors ${
              boxTab === "away"
                ? "bg-theme-secondary text-white border-theme-secondary"
                : "bg-theme-card text-theme-primary hover:bg-theme-bg-alt"
            }`}
          >
            {String(awayName).substring(0, 3)}
          </button>
          <button
            onClick={() => setBoxTab("matchup")}
            className={`text-[8px] font-black tracking-widest uppercase px-2 py-1 border border-theme-primary transition-colors ${
              boxTab === "matchup"
                ? "bg-theme-secondary text-white border-theme-secondary"
                : "bg-theme-card text-theme-primary hover:bg-theme-bg-alt"
            }`}
          >
            Compare
          </button>
          <button
            onClick={() => setBoxTab("home")}
            className={`text-[8px] font-black tracking-widest uppercase px-2 py-1 border border-theme-primary transition-colors ${
              boxTab === "home"
                ? "bg-theme-secondary text-white border-theme-secondary"
                : "bg-theme-card text-theme-primary hover:bg-theme-bg-alt"
            }`}
          >
            {String(homeName).substring(0, 3)}
          </button>
        </div>
      </div>
      {boxTab === "matchup" && gameData.teamStats && (
        <div className="border-2 border-theme-primary bg-theme-card shadow-[2px_2px_0_0_var(--c-border-primary)] text-[10px] font-mono font-bold text-theme-text flex flex-col animate-in fade-in duration-200">
          <div className="flex bg-theme-primary text-white uppercase tracking-widest border-b-2 border-theme-primary font-sans font-bold text-[9px]">
            <div className="w-1/3 p-1.5 pl-3 border-r border-white/30 text-left">
              Stat
            </div>
            <div className="w-1/3 p-1.5 text-center border-r border-white/30 truncate">
              {awayName}
            </div>
            <div className="w-1/3 p-1.5 text-center truncate">{homeName}</div>
          </div>
          {["ab", "r", "h", "rbi", "bb", "so", "lob"].map((stat) => (
            <div
              key={stat}
              className="flex border-b border-dotted border-theme-primary/30 last:border-0 hover:bg-theme-bg transition-colors"
            >
              <div className="w-1/3 p-1.5 pl-3 border-r border-theme-primary/30 uppercase text-theme-muted tracking-widest font-sans text-[9px]">
                {stat === "lob" ? "LOB" : stat}
              </div>
              <div className="w-1/3 p-1.5 text-center border-r border-theme-primary/30">
                {String(gameData.teamStats.away[stat])}
              </div>
              <div className="w-1/3 p-1.5 text-center">
                {String(gameData.teamStats.home[stat])}
              </div>
            </div>
          ))}
        </div>
      )}
      {boxTab === "away" && (
        <TeamBoxTable
          teamData={gameData.boxScore.away}
          onPlayerClick={onPlayerClick}
        />
      )}
      {boxTab === "home" && (
        <TeamBoxTable
          teamData={gameData.boxScore.home}
          onPlayerClick={onPlayerClick}
        />
      )}
    </div>
  );
};

const MediaSlider = ({
  title,
  icon: Icon,
  items,
  isVideo,
  openMedia,
  gameName,
}: any) => {
  if (!items || items.length === 0) return null;
  return (
    <div className="mt-4 pt-4 border-t-2 border-dashed border-theme-primary/50">
      <h3 className={labelStyle + " mb-3 flex items-center"}>
        <Icon size={12} className="mr-1.5 text-theme-secondary" /> {title}
      </h3>
      <div
        className="flex overflow-x-auto space-x-3 pb-2"
        style={{ scrollbarWidth: "none" }}
      >
        {items.map((item: any, idx: number) => (
          <div
            key={`m-${item.id || idx}`}
            onClick={() =>
              openMedia &&
              openMedia({
                type: isVideo ? "video" : "article",
                title: item.headline || item.title,
                source: item.source || gameName,
                videoUrl: item.videoUrl,
                link: item.link,
                content: item.content,
                feed: isVideo
                  ? items.map((h: any) => ({
                      type: "video",
                      title: h.title,
                      source: gameName,
                      videoUrl: h.videoUrl,
                    }))
                  : undefined,
                index: idx,
              })
            }
            className={`flex-shrink-0 cursor-pointer group ${
              isVideo
                ? "w-40"
                : "w-48 bg-theme-card border-2 border-theme-primary p-3 shadow-[2px_2px_0_0_var(--c-border-primary)] hover:bg-theme-bg transition-colors"
            }`}
          >
            {isVideo ? (
              <div>
                <div className="relative border-y-[4px] border-x-2 border-dotted border-[#1A1A1A] bg-[#1A1A1A] h-24 flex items-center justify-center shadow-[2px_2px_0_0_var(--c-border-primary)] transition-transform group-active:translate-y-1 group-active:shadow-none overflow-hidden">
                  <div className="absolute inset-1 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gray-700 to-gray-900 border border-gray-600 z-0"></div>
                  <Play
                    className="text-white relative z-10 opacity-80 group-hover:opacity-100 group-hover:scale-110 transition-all"
                    size={24}
                    fill="currentColor"
                  />
                  <span className="absolute bottom-1 right-1 bg-black text-white font-mono text-[8px] px-1 border border-gray-600 z-10">
                    {item.duration}
                  </span>
                </div>
                <p className="text-[10px] font-bold font-theme-head text-theme-primary leading-tight mt-1.5 line-clamp-2">
                  {item.title}
                </p>
              </div>
            ) : (
              <div>
                <span className="text-[8px] font-black text-theme-secondary uppercase tracking-widest block mb-1">
                  {item.source}
                </span>
                <h4 className="text-[11px] font-bold font-theme-head text-theme-primary leading-snug line-clamp-3">
                  {item.headline || item.title}
                </h4>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const LineScoreTable = ({
  game,
  awayName,
  homeName,
}: {
  game: any;
  awayName: string;
  homeName: string;
}) => {
  const lsAway = game.lineScore?.away || [];
  const lsHome = game.lineScore?.home || [];
  const lsAwayRHE = game.lineScore?.awayRHE || [game.awayScore || 0, 0, 0];
  const lsHomeRHE = game.lineScore?.homeRHE || [game.homeScore || 0, 0, 0];
  const inningsCount = Math.max(9, lsAway.length, lsHome.length);
  const headers = Array.from({ length: inningsCount }, (_, i: number) => i + 1);

  const paddedAway = [...lsAway];
  const paddedHome = [...lsHome];
  while (paddedAway.length < inningsCount) paddedAway.push("");
  while (paddedHome.length < inningsCount) paddedHome.push("");

  return (
    <div
      className="overflow-x-auto w-full mb-4"
      style={{ scrollbarWidth: "none" }}
    >
      <table className="w-full min-w-[300px] text-center text-xs font-mono border-2 border-theme-primary bg-theme-card shadow-theme-primary">
        <thead className="bg-theme-primary text-white text-[9px]">
          <tr>
            <th className="p-1 text-left w-10 border-r border-white/30 pl-2 font-sans font-bold tracking-widest uppercase">
              Team
            </th>
            {headers.map((i: number) => (
              <th key={`th-${i}`} className="p-1">
                {i}
              </th>
            ))}
            <th className="p-1 border-l border-white/30 text-theme-secondary font-sans font-bold tracking-widest uppercase">
              R
            </th>
            <th className="p-1 font-sans font-bold tracking-widest uppercase">
              H
            </th>
            <th className="p-1 font-sans font-bold tracking-widest uppercase">
              E
            </th>
          </tr>
        </thead>
        <tbody className="font-bold text-theme-primary">
          <tr className="border-b border-theme-bg">
            <td className="p-1 text-left border-r border-theme-bg bg-theme-bg-alt pl-2 truncate max-w-[40px] font-sans text-[10px] tracking-widest uppercase">
              {String(awayName).substring(0, 3)}
            </td>
            {paddedAway.map((r: any, i: number) => (
              <td key={`a${i}`} className="p-1">
                {String(r)}
              </td>
            ))}
            <td className="p-1 border-l border-theme-bg bg-theme-bg-alt text-theme-secondary">
              {String(lsAwayRHE[0])}
            </td>
            <td className="p-1 bg-theme-bg-alt">{String(lsAwayRHE[1])}</td>
            <td className="p-1 bg-theme-bg-alt text-theme-muted">
              {String(lsAwayRHE[2])}
            </td>
          </tr>
          <tr>
            <td className="p-1 text-left border-r border-theme-bg bg-theme-bg-alt pl-2 truncate max-w-[40px] font-sans text-[10px] tracking-widest uppercase">
              {String(homeName).substring(0, 3)}
            </td>
            {paddedHome.map((r: any, i: number) => (
              <td key={`h${i}`} className="p-1">
                {String(r)}
              </td>
            ))}
            <td className="p-1 border-l border-theme-bg bg-theme-bg-alt text-theme-secondary">
              {String(lsHomeRHE[0])}
            </td>
            <td className="p-1 bg-theme-bg-alt">{String(lsHomeRHE[1])}</td>
            <td className="p-1 bg-theme-bg-alt text-theme-muted">
              {String(lsHomeRHE[2])}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const LiveAtBatCard = ({ play, liveData, isCurrent, onPlayerClick }: any) => {
  const matchup = play.matchup;
  const pitchEvents = play.playEvents?.filter((e: any) => e.isPitch) || [];

  const szTop =
    pitchEvents.length > 0 &&
    pitchEvents[pitchEvents.length - 1].pitchData?.strikeZoneTop
      ? pitchEvents[pitchEvents.length - 1].pitchData.strikeZoneTop
      : 3.5;
  const szBottom =
    pitchEvents.length > 0 &&
    pitchEvents[pitchEvents.length - 1].pitchData?.strikeZoneBottom
      ? pitchEvents[pitchEvents.length - 1].pitchData.strikeZoneBottom
      : 1.5;

  const szTopY = Math.max(0, 100 - szTop * 20);
  const szBottomY = Math.min(100, 100 - szBottom * 20);

  const batter = matchup?.batter?.fullName || "TBD";
  const pitcher = matchup?.pitcher?.fullName || "TBD";
  const pitcherId = matchup?.pitcher?.id;

  const onDeck = isCurrent
    ? liveData?.linescore?.offense?.onDeck?.fullName
    : null;
  const result =
    play.result?.description || play.result?.event || "In Progress";

  let pitchCount = 0;
  if (isCurrent && pitcherId) {
    const awayP = liveData.boxscore?.teams?.away?.players?.[`ID${pitcherId}`];
    const homeP = liveData.boxscore?.teams?.home?.players?.[`ID${pitcherId}`];
    pitchCount =
      awayP?.stats?.pitching?.numberOfPitches ||
      homeP?.stats?.pitching?.numberOfPitches ||
      0;
  }
  if (!pitchCount) {
    pitchCount =
      play.matchup?.pitcher?.pitchCount || play.count?.pitchCount || 0;
  }

  return (
    <div
      className={`flex flex-col h-full bg-theme-card border-2 ${
        isCurrent
          ? "border-theme-secondary shadow-[2px_2px_0_0_var(--c-secondary)]"
          : "border-theme-primary/50 shadow-[2px_2px_0_0_var(--c-border-primary)] opacity-90 hover:opacity-100"
      } p-2 transition-all`}
    >
      <div className="flex justify-between items-center mb-2 pb-1 border-b border-theme-primary/20">
        <span className="text-[9px] font-black text-theme-muted uppercase tracking-widest">
          {play.about?.halfInning === "top" ? "TOP" : "BOT"}{" "}
          {play.about?.inning}
        </span>
        <div className="flex space-x-2 text-[9px] font-mono font-black text-theme-primary">
          <span>
            {play.count?.balls || 0} - {play.count?.strikes || 0}
          </span>
          <span className="text-theme-secondary">•</span>
          <span>{play.count?.outs || 0} OUTS</span>
        </div>
      </div>

      <div className="flex gap-3 h-36">
        <div className="w-[45%] bg-[#F8FAFC] border-2 border-theme-primary/50 relative flex-shrink-0 shadow-inner flex items-center justify-center overflow-hidden">
          <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
            <rect
              x="26.4"
              y={szTopY}
              width="47.2"
              height={szBottomY - szTopY}
              fill="rgba(0, 45, 114, 0.1)"
              stroke="var(--c-primary)"
              strokeWidth="1.5"
              strokeDasharray="3,2"
            />
            <polygon
              points="26.4,90 73.6,90 73.6,94 50,100 26.4,94"
              fill="white"
              stroke="var(--c-primary)"
              strokeWidth="1.5"
              opacity="0.8"
            />
            {pitchEvents.map((p: any, idx: number) => {
              const px = p.pitchData?.coordinates?.pX;
              const pz = p.pitchData?.coordinates?.pZ;
              if (px === undefined || pz === undefined) return null;

              const cx = ((px + 1.5) / 3) * 100;
              const cy = 100 - pz * 20;
              const desc = p.details?.description || "";
              const isStrike = desc.includes("Strike");
              const isInPlay = desc.includes("In play");
              const isBall = desc.includes("Ball");

              let color = "var(--c-text-muted)";
              if (isStrike) color = "var(--c-secondary)";
              else if (isBall) color = "#10B981";
              else if (isInPlay) color = "var(--c-primary)";

              return (
                <g key={idx}>
                  <circle
                    cx={cx}
                    cy={cy}
                    r="6"
                    fill={color}
                    stroke="white"
                    strokeWidth="1.5"
                    className="drop-shadow-sm"
                  />
                  <text
                    x={cx}
                    y={cy}
                    fill="white"
                    fontSize="6"
                    fontWeight="bold"
                    fontFamily="monospace"
                    textAnchor="middle"
                    dominantBaseline="central"
                  >
                    {idx + 1}
                  </text>
                </g>
              );
            })}
          </svg>
        </div>
        <div className="w-[55%] flex flex-col justify-between py-0.5">
          <div className="bg-theme-bg border border-theme-primary/30 p-1.5 shadow-sm">
            <span className="text-[8px] font-sans font-black text-theme-muted uppercase tracking-widest block leading-none mb-1">
              Batter
            </span>
            <span
              className="font-black font-theme-head text-theme-primary text-sm leading-none truncate block cursor-pointer hover:underline hover:text-theme-secondary transition-colors"
              onClick={() => onPlayerClick(batter)}
            >
              {batter}
            </span>
          </div>

          {isCurrent && onDeck ? (
            <div className="bg-theme-bg-alt border border-theme-primary/30 p-1.5 shadow-sm">
              <span className="text-[8px] font-sans font-black text-theme-muted uppercase tracking-widest block leading-none mb-1">
                On Deck
              </span>
              <span
                className="font-bold font-sans text-theme-primary text-xs leading-none truncate block cursor-pointer hover:underline hover:text-theme-secondary transition-colors"
                onClick={() => onPlayerClick(onDeck)}
              >
                {onDeck}
              </span>
            </div>
          ) : (
            <div className="bg-theme-secondary/5 border border-theme-secondary/30 p-1.5 shadow-sm overflow-hidden flex flex-col justify-center min-h-[38px]">
              <span className="text-[8px] font-sans font-black text-theme-secondary uppercase tracking-widest block leading-none mb-1">
                Result
              </span>
              <span
                className="font-bold font-sans text-theme-primary text-[9px] leading-tight line-clamp-2"
                title={result}
              >
                {result}
              </span>
            </div>
          )}

          <div className="bg-theme-bg-alt border border-theme-primary/30 p-1.5 flex justify-between items-center shadow-sm">
            <div className="overflow-hidden pr-2">
              <span className="text-[8px] font-sans font-black text-theme-muted uppercase tracking-widest block leading-none mb-1">
                Pitcher
              </span>
              <span
                className="font-bold font-sans text-theme-primary text-xs leading-none truncate block cursor-pointer hover:underline hover:text-theme-secondary transition-colors"
                onClick={() => onPlayerClick(pitcher)}
              >
                {pitcher}
              </span>
            </div>
            <div className="text-center bg-theme-primary text-white px-1.5 py-1 flex-shrink-0 shadow-sm">
              <span className="block text-[7px] font-black uppercase tracking-widest leading-none mb-0.5">
                Pitches
              </span>
              <span className="block font-mono font-black text-[10px] leading-none">
                {pitchCount}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const LiveAtBat = ({
  liveData,
  onPlayerClick,
}: {
  liveData: any;
  onPlayerClick: any;
}) => {
  const plays = liveData?.plays?.allPlays || [];
  const validPlays = plays.filter((p: any) => p.matchup && p.matchup.batter);
  const scrollRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTo({
          left: scrollRef.current.scrollWidth,
          behavior: "smooth",
        });
      }
    }, 150);
    return () => clearTimeout(timer);
  }, [validPlays.length]);

  if (validPlays.length === 0) return null;

  return (
    <div className="mb-4 animate-in fade-in slide-in-from-bottom-2 duration-300">
      <div className="flex items-center justify-between mb-2">
        <h4 className={labelStyle + " flex items-center"}>
          <Radio
            size={12}
            className="mr-1.5 text-theme-secondary animate-pulse"
          />{" "}
          At-Bat History
        </h4>
        <div className="text-[8px] font-black uppercase tracking-widest text-theme-muted flex items-center bg-theme-bg px-2 py-0.5 border border-theme-primary/20 shadow-sm">
          <ChevronLeft size={10} className="mr-1" /> Swipe{" "}
          <ChevronRight size={10} className="ml-1" />
        </div>
      </div>

      <div
        ref={scrollRef}
        className="flex overflow-x-auto space-x-3 pb-3 snap-x snap-mandatory"
        style={{ scrollbarWidth: "none" }}
      >
        {validPlays.map((play: any, idx: number) => {
          const isCurrent = idx === validPlays.length - 1;
          return (
            <div
              key={play.about?.atBatIndex || idx}
              className="w-[85%] sm:w-[90%] flex-shrink-0 snap-center first:ml-0"
            >
              <LiveAtBatCard
                play={play}
                liveData={liveData}
                isCurrent={isCurrent}
                onPlayerClick={onPlayerClick}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

const GameExpandedDetails = ({
  game,
  openMedia,
  awayName,
  homeName,
  isLive,
  isLoadingLineup,
  boxScoreData,
  boxTab,
  setBoxTab,
  liveData,
  onPlayerClick,
}: any) => {
  const scoringPlays =
    liveData?.plays?.allPlays?.filter((p: any) => p.about?.isScoringPlay) || [];

  // Extract dynamic live boxscore & lineup data if the game is active
  const getActiveBox = () => {
    if (!liveData || !liveData.boxscore) return null;

    const parseTeam = (team: any) => ({
      batters: (team.batters || []).map((id: any) => {
        const p = team.players[`ID${id}`];
        return {
          id: p?.person?.id,
          name: p?.person?.boxscoreName || p?.person?.fullName || "Unknown",
          pos: p?.position?.abbreviation || "-",
          ab: p?.stats?.batting?.atBats || 0,
          r: p?.stats?.batting?.runs || 0,
          h: p?.stats?.batting?.hits || 0,
          rbi: p?.stats?.batting?.rbi || 0,
          bb: p?.stats?.batting?.baseOnBalls || 0,
          so: p?.stats?.batting?.strikeOuts || 0,
        };
      }),
      pitchers: (team.pitchers || []).map((id: any) => {
        const p = team.players[`ID${id}`];
        return {
          id: p?.person?.id,
          name: p?.person?.boxscoreName || p?.person?.fullName || "Unknown",
          ip: p?.stats?.pitching?.inningsPitched || "0.0",
          h: p?.stats?.pitching?.hits || 0,
          r: p?.stats?.pitching?.runs || 0,
          er: p?.stats?.pitching?.earnedRuns || 0,
          bb: p?.stats?.pitching?.baseOnBalls || 0,
          so: p?.stats?.pitching?.strikeOuts || 0,
          hr: p?.stats?.pitching?.homeRuns || 0,
          pitches: p?.stats?.pitching?.numberOfPitches || 0,
          strikes: p?.stats?.pitching?.strikes || 0,
        };
      }),
      lineup: (team.battingOrder || []).map((id: any) => {
        const p = team.players[`ID${id}`];
        return {
          id: p?.person?.id,
          name: p?.person?.boxscoreName || p?.person?.fullName || "Unknown",
          pos: p?.position?.abbreviation || "-",
        };
      }),
    });

    const away = parseTeam(liveData.boxscore.teams.away);
    const home = parseTeam(liveData.boxscore.teams.home);
    const tsAway = liveData.boxscore.teams.away.teamStats?.batting || {};
    const tsHome = liveData.boxscore.teams.home.teamStats?.batting || {};

    return {
      boxScore: { away, home },
      teamStats: {
        away: {
          ab: tsAway.atBats || 0,
          r: tsAway.runs || 0,
          h: tsAway.hits || 0,
          rbi: tsAway.rbi || 0,
          bb: tsAway.baseOnBalls || 0,
          so: tsAway.strikeOuts || 0,
          lob: tsAway.leftOnBase || 0,
        },
        home: {
          ab: tsHome.atBats || 0,
          r: tsHome.runs || 0,
          h: tsHome.hits || 0,
          rbi: tsHome.rbi || 0,
          bb: tsHome.baseOnBalls || 0,
          so: tsHome.strikeOuts || 0,
          lob: tsHome.leftOnBase || 0,
        },
      },
      lineups: { away: away.lineup, home: home.lineup },
    };
  };

  const liveBoxInfo = isLive ? getActiveBox() : null;
  const displayLineups = liveBoxInfo?.lineups || boxScoreData;
  const displayBoxScore = liveBoxInfo?.boxScore || game.boxScore;
  const displayTeamStats = liveBoxInfo?.teamStats || game.teamStats;
  const currentBatterId = liveData?.plays?.currentPlay?.matchup?.batter?.id;

  return (
    <div
      className="mt-4 pt-4 border-t-2 border-theme-primary animate-in slide-in-from-top-2 duration-200 relative z-10"
      onClick={(e) => e.stopPropagation()}
    >
      {liveData && (
        <LiveAtBat liveData={liveData} onPlayerClick={onPlayerClick} />
      )}
      {isLive ? (
        <div className="mb-4">
          <h4 className={labelStyle + " mb-2 flex items-center"}>
            <Newspaper size={12} className="mr-1.5 text-theme-secondary" /> Line
            Score
          </h4>
          <LineScoreTable game={game} awayName={awayName} homeName={homeName} />
        </div>
      ) : (
        <div className="mb-4">
          <h4 className={labelStyle + " mb-2 flex items-center"}>
            <Users size={12} className="mr-1.5 text-theme-secondary" />{" "}
            Probables
          </h4>
          <div className="flex justify-between text-[9px] font-mono text-theme-text bg-theme-bg-alt border-2 border-theme-primary shadow-[2px_2px_0_0_var(--c-border-primary)] p-3">
            <div className="flex flex-col w-1/2 border-r-2 border-dashed border-theme-primary/30 pr-2">
              <span className="font-bold text-theme-secondary uppercase mb-1 font-sans">
                {awayName} (Away)
              </span>
              <span
                className="font-black text-theme-primary text-xs uppercase tracking-wider truncate font-theme-head cursor-pointer hover:underline hover:text-theme-secondary"
                onClick={() => onPlayerClick(game.probablePitcherAway)}
              >
                {game.probablePitcherAway || "TBD"}
              </span>
              {game.probablePitcherAway &&
                game.probablePitcherAway !== "TBD" && (
                  <span className="text-[9px] font-sans font-bold text-theme-muted uppercase tracking-widest mt-0.5">
                    ERA:{" "}
                    {game.probablePitcherAwayEra === 0 ||
                    game.probablePitcherAwayEra === "0"
                      ? "0.00"
                      : game.probablePitcherAwayEra ?? "-.--"}
                  </span>
                )}
            </div>
            <div className="flex flex-col w-1/2 pl-3">
              <span className="font-bold text-theme-secondary uppercase mb-1 font-sans">
                {homeName} (Home)
              </span>
              <span
                className="font-black text-theme-primary text-xs uppercase tracking-wider truncate font-theme-head cursor-pointer hover:underline hover:text-theme-secondary"
                onClick={() => onPlayerClick(game.probablePitcherHome)}
              >
                {game.probablePitcherHome || "TBD"}
              </span>
              {game.probablePitcherHome &&
                game.probablePitcherHome !== "TBD" && (
                  <span className="text-[9px] font-sans font-bold text-theme-muted uppercase tracking-widest mt-0.5">
                    ERA:{" "}
                    {game.probablePitcherHomeEra === 0 ||
                    game.probablePitcherHomeEra === "0"
                      ? "0.00"
                      : game.probablePitcherHomeEra ?? "-.--"}
                  </span>
                )}
            </div>
          </div>
        </div>
      )}

      {scoringPlays.length > 0 && (
        <div className="mb-4">
          <h4 className={labelStyle + " mb-2 flex items-center"}>
            <PlayCircle size={12} className="mr-1.5 text-theme-secondary" />{" "}
            Scoring Plays
          </h4>
          <div
            className="bg-theme-card border-2 border-theme-primary shadow-[2px_2px_0_0_var(--c-border-primary)] flex flex-col max-h-48 overflow-y-auto"
            style={{ scrollbarWidth: "none" }}
          >
            {scoringPlays.map((play: any, idx: number) => (
              <div
                key={`sp-${idx}`}
                className="p-2 border-b border-dotted border-theme-primary/30 last:border-0 flex gap-2 hover:bg-theme-bg transition-colors"
              >
                <div className="w-8 flex-shrink-0 flex flex-col items-center justify-center border-r border-theme-primary/20 pr-1">
                  <span className="text-[7px] font-black tracking-widest uppercase text-theme-muted">
                    {play.about?.halfInning === "top" ? "TOP" : "BOT"}
                  </span>
                  <span className="font-mono font-bold text-theme-primary text-[10px]">
                    {play.about?.inning}
                  </span>
                </div>
                <div className="flex-1 text-[9px] font-sans text-theme-text flex items-center leading-snug">
                  {play.result?.description}
                </div>
                <div className="w-10 flex-shrink-0 flex flex-col items-center justify-center border-l border-theme-primary/20 pl-1">
                  <span className="font-mono font-black text-theme-secondary text-[10px]">
                    {play.result?.awayScore}-{play.result?.homeScore}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {isLoadingLineup && (
        <div className="mt-4 text-center text-theme-primary font-bold animate-pulse text-[10px] tracking-widest uppercase">
          Fetching Data...
        </div>
      )}

      {!isLoadingLineup &&
        displayLineups &&
        (displayLineups.away?.length > 0 ||
          displayLineups.home?.length > 0) && (
          <div className="mt-4 border-t-2 border-dashed border-theme-primary/30 pt-3">
            <h4 className={labelStyle + " mb-2 flex items-center"}>
              <Users size={12} className="mr-1.5 text-theme-secondary" />{" "}
              {isLive ? "Current Lineups" : "Starting Lineups"}
            </h4>
            <div className="grid grid-cols-2 gap-2 text-[9px] font-sans text-theme-text mb-4 bg-theme-card border-2 border-theme-primary shadow-[2px_2px_0_0_var(--c-border-primary)] p-2">
              <div>
                <span className="font-bold text-theme-secondary uppercase border-b border-theme-bg block mb-1 pb-0.5">
                  {awayName} (Away)
                </span>
                {displayLineups.away.length > 0 ? (
                  <ol className="space-y-0.5 opacity-80 font-bold">
                    {displayLineups.away.map((b: any, i: number) => (
                      <li
                        key={`al-${i}`}
                        className={`truncate px-1 ${
                          b.id === currentBatterId
                            ? "bg-theme-secondary text-white shadow-sm"
                            : ""
                        }`}
                      >
                        <span className="font-mono mr-1">{i + 1}.</span>{" "}
                        <span
                          className={`cursor-pointer hover:underline transition-colors ${
                            b.id === currentBatterId
                              ? "hover:text-white"
                              : "hover:text-theme-secondary"
                          }`}
                          onClick={() => onPlayerClick(b.name)}
                        >
                          {b.name}
                        </span>{" "}
                        <span
                          className={`text-[8px] ml-0.5 ${
                            b.id === currentBatterId
                              ? "text-white/80"
                              : "text-theme-muted"
                          }`}
                        >
                          {b.pos}
                        </span>
                      </li>
                    ))}
                  </ol>
                ) : (
                  <span className="text-theme-muted italic">TBA</span>
                )}
              </div>
              <div>
                <span className="font-bold text-theme-secondary uppercase border-b border-theme-bg block mb-1 pb-0.5">
                  {homeName} (Home)
                </span>
                {displayLineups.home.length > 0 ? (
                  <ol className="space-y-0.5 font-bold">
                    {displayLineups.home.map((b: any, i: number) => (
                      <li
                        key={`hl-${i}`}
                        className={`truncate px-1 ${
                          b.id === currentBatterId
                            ? "bg-theme-secondary text-white shadow-sm"
                            : ""
                        }`}
                      >
                        <span className="font-mono mr-1">{i + 1}.</span>{" "}
                        <span
                          className={`cursor-pointer hover:underline transition-colors ${
                            b.id === currentBatterId
                              ? "hover:text-white"
                              : "hover:text-theme-secondary"
                          }`}
                          onClick={() => onPlayerClick(b.name)}
                        >
                          {b.name}
                        </span>{" "}
                        <span
                          className={`text-[8px] ml-0.5 ${
                            b.id === currentBatterId
                              ? "text-white/80"
                              : "text-theme-muted"
                          }`}
                        >
                          {b.pos}
                        </span>
                      </li>
                    ))}
                  </ol>
                ) : (
                  <span className="text-theme-muted italic">TBA</span>
                )}
              </div>
            </div>
          </div>
        )}

      {game?.performers && game.performers.length > 0 && (
        <div className="mb-4">
          <h4 className={labelStyle + " mb-2 flex items-center"}>
            <Trophy size={12} className="mr-1.5 text-theme-secondary" /> Notable
            Performances
          </h4>
          <ul className="space-y-1 text-[11px] font-mono text-theme-text bg-theme-card p-3 border-2 border-theme-primary shadow-theme-primary">
            {game.performers.map((perf: string, i: number) => (
              <li
                key={`perf-${i}`}
                className="flex border-b border-dotted border-theme-muted last:border-0 pb-1.5 pt-0.5 last:pb-0"
              >
                <span className="text-theme-secondary font-black mr-2">»</span>{" "}
                {String(perf)}
              </li>
            ))}
          </ul>
        </div>
      )}

      <BoxScoreView
        gameData={{
          ...game,
          boxScore: displayBoxScore,
          teamStats: displayTeamStats,
        }}
        boxTab={boxTab}
        setBoxTab={setBoxTab}
        awayName={awayName}
        homeName={homeName}
        onPlayerClick={onPlayerClick}
      />
      <PitchingDetails
        boxScore={displayBoxScore}
        awayName={awayName}
        homeName={homeName}
        onPlayerClick={onPlayerClick}
      />
      <MediaSlider
        title="Post-Game Coverage"
        icon={Newspaper}
        items={game.news}
        isVideo={false}
        openMedia={openMedia}
      />
      <MediaSlider
        title="Game Highlights"
        icon={PlayCircle}
        items={game.highlights}
        isVideo={true}
        openMedia={openMedia}
        gameName="Highlights"
      />
    </div>
  );
};

const GamecastCard = ({
  game,
  openMedia,
  onPlayerClick,
}: {
  game: any;
  openMedia?: any;
  onPlayerClick?: any;
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [boxScoreData, setBoxScoreData] = useState<any>(null);
  const [isLoadingLineup, setIsLoadingLineup] = useState<boolean>(false);
  const [boxTab, setBoxTab] = useState<string>("matchup");
  const [liveData, setLiveData] = useState<any>(null);
  const [showRunners, setShowRunners] = useState<boolean>(false);

  const isLive = game.status === "Live" || game.status === "In Progress";

  useEffect(() => {
    let interval: any;
    if (isLive) {
      const fetchLive = async () => {
        try {
          const res = await fetch(
            `https://statsapi.mlb.com/api/v1.1/game/${game.id}/feed/live`
          ).then((r) => r.json());
          setLiveData(res.liveData);
        } catch (e) {}
      };
      fetchLive();
      interval = setInterval(fetchLive, 10000);
    }
    return () => clearInterval(interval);
  }, [isLive, game.id]);

  const handleExpand = async () => {
    const willExpand = !isExpanded;
    setIsExpanded(willExpand);
    if (willExpand && !boxScoreData && !game.boxScore) {
      setIsLoadingLineup(true);
      try {
        const bsRes = await fetch(
          `https://statsapi.mlb.com/api/v1/game/${game.id}/boxscore`
        ).then((r) => r.json());
        const parseLineup = (team: any) => {
          const order = team.battingOrder || team.batters || [];
          return order.slice(0, 9).map((id: any) => {
            const p = team.players[`ID${id}`];
            return {
              id: p?.person?.id,
              name: p?.person?.boxscoreName || p?.person?.fullName || "Unknown",
              pos: p?.position?.abbreviation || "-",
            };
          });
        };
        setBoxScoreData({
          away: parseLineup(bsRes.teams.away),
          home: parseLineup(bsRes.teams.home),
        });
      } catch (e) {}
      setIsLoadingLineup(false);
    }
  };

  if (!game) return null;
  const awayName = game.isHome ? game.opponent : "METS";
  const homeName = game.isHome ? "METS" : game.opponent;

  const displayHomeScore = liveData
    ? liveData.linescore?.teams?.home?.runs ?? game.homeScore
    : game.homeScore;
  const displayAwayScore = liveData
    ? liveData.linescore?.teams?.away?.runs ?? game.awayScore
    : game.awayScore;
  const displayInning = liveData?.linescore
    ? `${liveData.linescore.isTopInning ? "TOP" : "BOT"} ${
        liveData.linescore.currentInning || 1
      }`
    : game.inning || "MID 1";
  const displayOuts = liveData?.linescore
    ? liveData.linescore.outs || 0
    : game.outs || 0;
  const displayBases = liveData?.linescore
    ? {
        first: !!liveData.linescore.offense?.first,
        second: !!liveData.linescore.offense?.second,
        third: !!liveData.linescore.offense?.third,
      }
    : game.bases;

  const runners = liveData?.linescore?.offense
    ? {
        first: liveData.linescore.offense.first?.fullName,
        second: liveData.linescore.offense.second?.fullName,
        third: liveData.linescore.offense.third?.fullName,
      }
    : null;

  const displayBatter =
    liveData?.plays?.currentPlay?.matchup?.batter?.fullName ||
    game.batter ||
    "TBD";
  const displayPitcher =
    liveData?.plays?.currentPlay?.matchup?.pitcher?.fullName ||
    game.pitcher ||
    "TBD";

  const isAwayBatting = liveData?.linescore?.isTopInning === true;
  const isHomeBatting = liveData?.linescore?.isTopInning === false;

  const awayAbbr =
    awayName === "METS"
      ? "NYM"
      : String(awayName).substring(0, 3).toUpperCase();
  const homeAbbr =
    homeName === "METS"
      ? "NYM"
      : String(homeName).substring(0, 3).toUpperCase();

  const renderMetaInfo = () => (
    <div className="relative z-10 mt-4 border-t-2 border-dashed border-theme-primary/30 pt-4 mb-2">
      <div className="flex items-center justify-center space-x-2 sm:space-x-3 text-[9px] sm:text-[10px] mb-4 font-bold text-theme-text bg-theme-bg-alt border-2 border-theme-primary px-2 py-1.5 shadow-[2px_2px_0_0_var(--c-border-primary)] w-full overflow-hidden">
        <div className="flex items-center space-x-1 flex-shrink-0">
          <Calendar size={12} className="text-theme-secondary" />
          <span className="uppercase tracking-widest font-sans truncate">
            {game.date}
          </span>
        </div>
        <span className="text-theme-primary opacity-50 flex-shrink-0">•</span>
        <div className="flex items-center space-x-1 flex-shrink-0">
          <Sun size={12} className="text-theme-secondary fill-current" />
          <span className="uppercase tracking-widest font-black text-theme-primary font-sans truncate">
            {game.time || "TBD"}
          </span>
        </div>
        <span className="text-theme-primary opacity-50 flex-shrink-0">•</span>
        <div className="flex items-center space-x-1 overflow-hidden">
          <MapPin size={12} className="text-theme-secondary flex-shrink-0" />
          <span className="uppercase tracking-widest font-sans truncate">
            {game.venue || "TBD"}
          </span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 text-sm">
        <a
          href={`https://www.mlb.com/tv/g${game.id}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center space-x-2 font-bold text-theme-primary hover:bg-theme-bg-alt transition-colors cursor-pointer border-2 border-theme-primary p-2 bg-theme-card shadow-[2px_2px_0_0_var(--c-border-primary)] active:translate-y-[2px] active:shadow-none"
        >
          <Tv size={14} className="text-theme-secondary flex-shrink-0" />
          <span className="uppercase font-sans font-black tracking-widest text-[9px] mt-0.5 truncate">
            Watch
          </span>
        </a>
        <a
          href={`https://www.mlb.com/tv/g${game.id}?media_type=audio`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center space-x-2 font-bold text-theme-primary hover:bg-theme-bg-alt transition-colors cursor-pointer border-2 border-theme-primary p-2 bg-theme-card shadow-[2px_2px_0_0_var(--c-border-primary)] active:translate-y-[2px] active:shadow-none"
        >
          <Radio size={14} className="text-theme-secondary flex-shrink-0" />
          <span className="uppercase font-sans font-black tracking-widest text-[9px] mt-0.5 truncate">
            Listen
          </span>
        </a>
      </div>
    </div>
  );

  return (
    <div className={cardStyle}>
      <div
        className="bg-theme-primary p-3 text-white flex justify-between items-center border-b-2 border-theme-secondary cursor-pointer hover:bg-theme-secondary/90 transition-colors"
        onClick={handleExpand}
      >
        <p className="text-theme-secondary font-bold text-xs font-sans uppercase tracking-widest">
          {isLive ? "Live Matchup" : "Upcoming Matchup"}
        </p>
        <div className="flex items-center space-x-2">
          <div className="bg-theme-card text-theme-primary border-2 border-transparent p-0.5 rounded-full shadow-[1px_1px_0_0_var(--c-secondary)] transition-all">
            {isExpanded ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
          </div>
        </div>
      </div>

      <div className="p-5 relative overflow-hidden bg-theme-card">
        <div className="absolute -right-4 -bottom-4 opacity-5 text-[120px] font-black font-theme-head italic text-theme-primary pointer-events-none">
          NY
        </div>
        {isLive ? (
          <div className="bg-theme-bg border-2 border-theme-primary p-3 mb-5 shadow-theme-primary flex flex-col relative z-10">
            <div className="flex justify-between items-center w-full mb-3 pb-3 border-b-2 border-dashed border-theme-primary/50">
              <div className="flex flex-col items-center w-1/4">
                <div
                  className={`flex items-center space-x-1.5 mb-1 px-2 py-0.5 border-2 transition-all duration-300 ${
                    isAwayBatting
                      ? "bg-theme-secondary text-white border-theme-primary shadow-[2px_2px_0_0_var(--c-primary)] scale-110"
                      : "bg-transparent border-transparent text-theme-muted"
                  }`}
                >
                  {isAwayBatting && (
                    <div className="w-1.5 h-1.5 bg-white rounded-full animate-pulse" />
                  )}
                  <span className="font-sans text-[10px] font-bold tracking-widest uppercase">
                    {awayAbbr}
                  </span>
                </div>
                <span
                  className={`text-4xl font-mono font-black leading-none transition-colors duration-300 ${
                    isAwayBatting
                      ? "text-theme-primary"
                      : "text-theme-primary opacity-50"
                  }`}
                >
                  {displayAwayScore ?? 0}
                </span>
              </div>
              <div className="relative flex flex-col items-center justify-center w-2/4">
                <div
                  className="cursor-pointer hover:scale-105 transition-transform flex flex-col items-center"
                  onClick={() => setShowRunners(!showRunners)}
                  title="Click to view baserunners"
                >
                  <svg
                    viewBox="0 0 100 100"
                    className="w-14 h-14 mb-2 overflow-visible"
                  >
                    <path
                      d="M 50 85 L 85 50 L 50 15 L 15 50 Z"
                      fill="none"
                      stroke="var(--c-primary)"
                      strokeWidth="4"
                    />
                    <polygon
                      points="50,4 61,15 50,26 39,15"
                      fill={
                        displayBases?.second
                          ? "var(--c-secondary)"
                          : "var(--c-card)"
                      }
                      stroke="var(--c-primary)"
                      strokeWidth="3"
                      strokeLinejoin="miter"
                    />
                    <polygon
                      points="85,39 96,50 85,61 74,50"
                      fill={
                        displayBases?.first
                          ? "var(--c-secondary)"
                          : "var(--c-card)"
                      }
                      stroke="var(--c-primary)"
                      strokeWidth="3"
                      strokeLinejoin="miter"
                    />
                    <polygon
                      points="15,39 26,50 15,61 4,50"
                      fill={
                        displayBases?.third
                          ? "var(--c-secondary)"
                          : "var(--c-card)"
                      }
                      stroke="var(--c-primary)"
                      strokeWidth="3"
                      strokeLinejoin="miter"
                    />
                    <polygon
                      points="44,80 56,80 56,86 50,92 44,86"
                      fill="var(--c-card)"
                      stroke="var(--c-primary)"
                      strokeWidth="3"
                      strokeLinejoin="miter"
                    />
                  </svg>
                  <div className="flex items-center space-x-2 text-[9px] font-mono font-black text-theme-primary tracking-widest uppercase">
                    <span>{displayInning}</span>
                    <span className="text-theme-secondary">•</span>
                    <span>{displayOuts} OUTS</span>
                  </div>
                </div>

                {showRunners && (
                  <div
                    className="absolute top-[80%] left-1/2 -translate-x-1/2 w-[140px] bg-theme-card border-2 border-theme-primary shadow-[2px_2px_0_0_var(--c-border-primary)] p-2 z-30 text-[9px] font-sans font-bold uppercase animate-in zoom-in-95 duration-200 cursor-pointer"
                    onClick={() => setShowRunners(false)}
                  >
                    <div className="flex justify-between items-center border-b border-dotted border-theme-primary/40 pb-1 mb-1">
                      <span className="text-theme-secondary">3B</span>
                      <span className="text-theme-primary truncate pl-2">
                        {runners?.third || "--"}
                      </span>
                    </div>
                    <div className="flex justify-between items-center border-b border-dotted border-theme-primary/40 pb-1 mb-1">
                      <span className="text-theme-secondary">2B</span>
                      <span className="text-theme-primary truncate pl-2">
                        {runners?.second || "--"}
                      </span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-theme-secondary">1B</span>
                      <span className="text-theme-primary truncate pl-2">
                        {runners?.first || "--"}
                      </span>
                    </div>
                  </div>
                )}
              </div>
              <div className="flex flex-col items-center w-1/4">
                <div
                  className={`flex items-center space-x-1.5 mb-1 px-2 py-0.5 border-2 transition-all duration-300 ${
                    isHomeBatting
                      ? "bg-theme-secondary text-white border-theme-primary shadow-[2px_2px_0_0_var(--c-primary)] scale-110"
                      : "bg-transparent border-transparent text-theme-muted"
                  }`}
                >
                  {isHomeBatting && (
                    <div className="w-1.5 h-1.5 bg-white rounded-full animate-pulse" />
                  )}
                  <span className="font-sans text-[10px] font-bold tracking-widest uppercase">
                    {homeAbbr}
                  </span>
                </div>
                <span
                  className={`text-4xl font-mono font-black leading-none transition-colors duration-300 ${
                    isHomeBatting
                      ? "text-theme-primary"
                      : "text-theme-primary opacity-50"
                  }`}
                >
                  {displayHomeScore ?? 0}
                </span>
              </div>
            </div>
            <div className="flex justify-between items-center px-1">
              <div className="flex flex-col text-theme-text font-sans text-[10px] font-bold">
                <div className="flex flex-col space-y-1 mb-2">
                  <span>
                    <span className="text-theme-muted tracking-widest">P:</span>{" "}
                    <span className="uppercase text-theme-primary">
                      {displayPitcher}
                    </span>
                  </span>
                  <span>
                    <span className="text-theme-muted tracking-widest">B:</span>{" "}
                    <span className="uppercase text-theme-primary">
                      {displayBatter}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <h3 className="text-3xl font-black font-theme-head text-theme-primary mb-1 leading-tight z-10 relative">
            {game.opponent || "Loading Data..."}
          </h3>
        )}

        {(!isExpanded || !isLive) && renderMetaInfo()}

        {isExpanded && (
          <GameExpandedDetails
            game={game}
            openMedia={openMedia}
            awayName={awayName}
            homeName={homeName}
            isLive={isLive}
            isLoadingLineup={isLoadingLineup}
            boxScoreData={boxScoreData}
            boxTab={boxTab}
            setBoxTab={setBoxTab}
            liveData={liveData}
            onPlayerClick={onPlayerClick}
          />
        )}

        {isExpanded && isLive && renderMetaInfo()}

        <UniformSwatch name={game.uniform || "Home Pinstripes"} />
      </div>
    </div>
  );
};

const PastGameCard = ({
  game,
  dateString,
  title = "Last Time Out",
  openMedia,
  onPlayerClick,
}: any) => {
  const [expandedData, setExpandedData] = useState<any>(
    game.boxScore ? game : null
  );
  const [isBoxExpanded, setIsBoxExpanded] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [boxTab, setBoxTab] = useState<string>("matchup");

  const handleExpand = async () => {
    const willExpand = !isBoxExpanded;
    setIsBoxExpanded(willExpand);
    if (willExpand && !expandedData) {
      setIsLoading(true);
      try {
        const bsRes = await fetch(
          `https://statsapi.mlb.com/api/v1/game/${game.id}/boxscore`
        ).then((r) => r.json());
        const ctRes = await fetch(
          `https://statsapi.mlb.com/api/v1/game/${game.id}/content`
        ).then((r) => r.json());
        const liveRes = await fetch(
          `https://statsapi.mlb.com/api/v1.1/game/${game.id}/feed/live`
        ).then((r) => r.json());

        const parseBoxTeam = (team: any) => ({
          batters: (team.batters || []).map((id: any) => {
            const p = team.players[`ID${id}`];
            return {
              name: p?.person?.fullName || "Unknown",
              pos: p?.position?.abbreviation || "-",
              ab: p?.stats?.batting?.atBats || 0,
              r: p?.stats?.batting?.runs || 0,
              h: p?.stats?.batting?.hits || 0,
              rbi: p?.stats?.batting?.rbi || 0,
              bb: p?.stats?.batting?.baseOnBalls || 0,
              so: p?.stats?.batting?.strikeOuts || 0,
            };
          }),
          pitchers: (team.pitchers || []).map((id: any) => {
            const p = team.players[`ID${id}`];
            return {
              name: p?.person?.fullName || "Unknown",
              ip: p?.stats?.pitching?.inningsPitched || "0.0",
              h: p?.stats?.pitching?.hits || 0,
              r: p?.stats?.pitching?.runs || 0,
              er: p?.stats?.pitching?.earnedRuns || 0,
              bb: p?.stats?.pitching?.baseOnBalls || 0,
              so: p?.stats?.pitching?.strikeOuts || 0,
              hr: p?.stats?.pitching?.homeRuns || 0,
              pitches: p?.stats?.pitching?.numberOfPitches || 0,
              strikes: p?.stats?.pitching?.strikes || 0,
            };
          }),
        });

        const boxScore = {
          away: parseBoxTeam(bsRes.teams.away),
          home: parseBoxTeam(bsRes.teams.home),
        };
        const teamStats = {
          away: {
            ab: bsRes.teams.away.teamStats.batting.atBats || 0,
            r: bsRes.teams.away.teamStats.batting.runs || 0,
            h: bsRes.teams.away.teamStats.batting.hits || 0,
            rbi: bsRes.teams.away.teamStats.batting.rbi || 0,
            bb: bsRes.teams.away.teamStats.batting.baseOnBalls || 0,
            so: bsRes.teams.away.teamStats.batting.strikeOuts || 0,
            lob: bsRes.teams.away.teamStats.batting.leftOnBase || 0,
          },
          home: {
            ab: bsRes.teams.home.teamStats.batting.atBats || 0,
            r: bsRes.teams.home.teamStats.batting.runs || 0,
            h: bsRes.teams.home.teamStats.batting.hits || 0,
            rbi: bsRes.teams.home.teamStats.batting.rbi || 0,
            bb: bsRes.teams.home.teamStats.batting.baseOnBalls || 0,
            so: bsRes.teams.home.teamStats.batting.strikeOuts || 0,
            lob: bsRes.teams.home.teamStats.batting.leftOnBase || 0,
          },
        };

        const highlights =
          ctRes.highlights?.highlights?.items
            ?.slice(0, 6)
            .map((item: any, idx: number) => {
              const mp4 =
                item.playbacks?.find((p: any) => p.url.includes(".mp4")) ||
                item.playbacks?.[0];
              return {
                id: item.mediaPlaybackId || idx,
                title: item.headline,
                duration: item.duration || "",
                videoUrl: mp4?.url,
              };
            })
            .filter((h: any) => h.videoUrl) || [];

        const news = [];
        if (ctRes.editorial?.recap?.mlb) {
          news.push({
            id: 1,
            source: "MLB.com",
            headline: ctRes.editorial.recap.mlb.headline,
            content: ctRes.editorial.recap.mlb.body,
          });
        }

        const perfs = [];
        const homeTeamAbbr = game.isHome
          ? "NYM"
          : String(game.opponent).substring(0, 3).toUpperCase();
        const awayTeamAbbr = game.isHome
          ? String(game.opponent).substring(0, 3).toUpperCase()
          : "NYM";

        const bestHomeHitter = [...boxScore.home.batters].sort(
          (a: any, b: any) => b.rbi - a.rbi
        )[0];
        if (bestHomeHitter?.rbi > 0)
          perfs.push(
            `${bestHomeHitter.name} (${homeTeamAbbr}): ${bestHomeHitter.h}-${bestHomeHitter.ab}, ${bestHomeHitter.rbi} RBI`
          );
        const bestAwayHitter = [...boxScore.away.batters].sort(
          (a: any, b: any) => b.rbi - a.rbi
        )[0];
        if (bestAwayHitter?.rbi > 0)
          perfs.push(
            `${bestAwayHitter.name} (${awayTeamAbbr}): ${bestAwayHitter.h}-${bestAwayHitter.ab}, ${bestAwayHitter.rbi} RBI`
          );

        setExpandedData({
          ...game,
          boxScore,
          teamStats,
          highlights,
          news,
          performers: perfs,
          liveData: liveRes.liveData,
        });
      } catch (e) {}
      setIsLoading(false);
    }
  };

  const displayGame = expandedData || game;
  const homeLogo = displayGame?.isHome ? "NY" : displayGame?.logo;
  const awayLogo = displayGame?.isHome ? displayGame?.logo : "NY";
  const homeName = displayGame?.isHome ? "METS" : displayGame?.opponent;
  const awayName = displayGame?.isHome ? displayGame?.opponent : "METS";
  const homeScore = displayGame?.isHome
    ? displayGame?.metsScore
    : displayGame?.oppScore;
  const awayScore = displayGame?.isHome
    ? displayGame?.oppScore
    : displayGame?.metsScore;

  return (
    <section className="mb-8">
      {title && (
        <div className="flex items-center space-x-2 mb-2">
          <div className="w-2 h-2 bg-theme-secondary border border-theme-primary"></div>
          <h2 className="text-sm font-bold text-theme-primary uppercase tracking-widest font-theme-head">
            {title}
          </h2>
        </div>
      )}
      <div className={cardStyle}>
        <div
          className="bg-theme-primary p-3 text-white flex justify-between items-center border-b-2 border-theme-secondary cursor-pointer hover:bg-theme-secondary/90 transition-colors"
          onClick={handleExpand}
        >
          <p className="text-theme-secondary font-bold text-[10px] uppercase tracking-widest">
            {dateString}
          </p>
          <div className="flex items-center space-x-2">
            <span className="font-theme-head font-bold italic border border-white/30 px-2 py-0.5 text-[10px]">
              FINAL {displayGame?.result}
            </span>
            <div className="bg-theme-card text-theme-primary border-2 border-transparent p-0.5 rounded-full shadow-[1px_1px_0_0_var(--c-secondary)] transition-all">
              {isBoxExpanded ? (
                <ChevronUp size={14} />
              ) : (
                <ChevronDown size={14} />
              )}
            </div>
          </div>
        </div>

        <div
          className="p-4 bg-theme-bg-alt border-b-2 border-theme-primary cursor-pointer group hover:bg-theme-bg transition-colors"
          onClick={handleExpand}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div
                className={`w-8 h-8 rounded-full border-2 border-theme-primary flex items-center justify-center font-black font-theme-head text-sm shadow-[1px_1px_0_0_var(--c-border-primary)] ${
                  !displayGame?.isHome
                    ? "bg-theme-secondary text-white"
                    : "bg-theme-card text-theme-primary"
                }`}
              >
                {awayLogo}
              </div>
              <span className="font-theme-head font-black text-xl text-theme-primary">
                {awayName}
              </span>
            </div>
            <span className="font-mono text-3xl font-black text-theme-primary">
              {awayScore}
            </span>
          </div>
          <div className="my-2 border-t border-dashed border-theme-primary opacity-30"></div>
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div
                className={`w-8 h-8 rounded-full border-2 border-theme-primary flex items-center justify-center font-black font-theme-head text-sm shadow-[1px_1px_0_0_var(--c-border-primary)] ${
                  displayGame?.isHome
                    ? "bg-theme-secondary text-white"
                    : "bg-theme-card text-theme-primary"
                }`}
              >
                {homeLogo}
              </div>
              <span className="font-theme-head font-black text-xl text-theme-primary">
                {homeName}
              </span>
            </div>
            <span className="font-mono text-3xl font-black text-theme-primary">
              {homeScore}
            </span>
          </div>

          <div className="mt-4 flex justify-between text-[9px] uppercase tracking-widest font-bold text-theme-muted bg-theme-card border-2 border-theme-primary p-2 shadow-theme-inner">
            <p>
              W:{" "}
              <span className="text-theme-primary font-mono">
                {displayGame?.wp || "N/A"}
              </span>
            </p>
            <p>
              L:{" "}
              <span className="text-theme-primary font-mono">
                {displayGame?.lp || "N/A"}
              </span>
            </p>
            {displayGame?.sv && (
              <p>
                SV:{" "}
                <span className="text-theme-primary font-mono">
                  {displayGame.sv}
                </span>
              </p>
            )}
          </div>
        </div>

        {isBoxExpanded && (
          <div
            className="p-4 bg-theme-bg-alt border-t-2 border-theme-primary animate-in slide-in-from-top-2 duration-200 cursor-default"
            onClick={(e) => e.stopPropagation()}
          >
            {isLoading ? (
              <div className="p-4 text-center text-theme-primary font-bold animate-pulse text-[10px] tracking-widest uppercase">
                Fetching Complete Game Data from MLB...
              </div>
            ) : (
              <GameExpandedDetails
                game={displayGame}
                openMedia={openMedia}
                awayName={awayName}
                homeName={homeName}
                isLive={true}
                isLoadingLineup={false}
                boxScoreData={null}
                boxTab={boxTab}
                setBoxTab={setBoxTab}
                liveData={displayGame.liveData}
                onPlayerClick={onPlayerClick}
              />
            )}
          </div>
        )}
      </div>
    </section>
  );
};

const HomeTab = ({ openMedia, nextGame, lastGame, onPlayerClick }: any) => {
  return (
    <div className="p-4 space-y-8">
      {nextGame ? (
        <section>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-theme-secondary border border-theme-primary"></div>
              <h2 className={labelStyle + " text-[14px]"}>
                {nextGame.status === "Live" ? "Live Gamecast" : "Up Next"}
              </h2>
            </div>
          </div>
          <GamecastCard
            game={nextGame}
            openMedia={openMedia}
            onPlayerClick={onPlayerClick}
          />
        </section>
      ) : (
        <div className="bg-theme-card border-2 border-theme-primary shadow-theme-primary p-4 text-center text-theme-primary font-bold font-sans uppercase tracking-widest text-[10px]">
          No Upcoming Games Scheduled
        </div>
      )}
      {lastGame && (
        <PastGameCard
          game={lastGame}
          dateString={lastGame.date}
          title="Last Time Out"
          openMedia={openMedia}
          onPlayerClick={onPlayerClick}
        />
      )}
    </div>
  );
};

const StandingsTable = ({ data, type }: any) => {
  return (
    <div className={cardStyle}>
      <div className="bg-theme-primary p-3 text-white text-sm font-black font-theme-head uppercase flex justify-between border-b-2 border-theme-secondary">
        <span>{data.name}</span>
        {type === "wildcard" && (
          <span className="text-theme-secondary text-[10px] tracking-widest mt-1 font-sans">
            Top 3 Qualify
          </span>
        )}
      </div>
      <div className="overflow-x-auto">
        <div className="min-w-[550px]">
          <div className="bg-theme-card p-2 text-[10px] font-bold text-theme-primary uppercase tracking-widest flex border-b-2 border-theme-primary font-sans">
            <span className="w-8"></span>
            <span className="w-40 sticky left-0 bg-theme-card z-10 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.3)]">
              Club
            </span>
            <span className="w-10 text-center">W</span>
            <span className="w-10 text-center">L</span>
            <span className="w-14 text-center">PCT</span>
            <span className="w-14 text-center text-theme-secondary">
              {type === "division" ? "GB" : "WCGB"}
            </span>
            {type === "division" && (
              <div className="contents">
                <span className="w-12 text-center">L10</span>
                <span className="w-12 text-center">STRK</span>
                <span className="w-12 text-center">DIFF</span>
              </div>
            )}
          </div>
          {data.teams.map((team: any, idx: number) => {
            const isMets = team.team === "New York Mets";
            return (
              <div
                key={team.team}
                className={`flex items-center p-3 text-sm border-b-2 border-theme-bg last:border-0 ${
                  type === "wildcard" && idx === 2
                    ? "border-b-4 border-b-theme-secondary pb-4 mb-1"
                    : ""
                } ${
                  isMets ? "bg-theme-secondary bg-opacity-10" : "bg-theme-card"
                }`}
              >
                <span
                  className={`w-8 text-xs font-black text-center font-mono ${
                    type === "wildcard" && idx < 3
                      ? "text-green-600"
                      : "text-theme-muted"
                  }`}
                >
                  {idx + 1}
                </span>
                <span
                  className={`w-40 font-black font-theme-head uppercase sticky left-0 z-10 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)] pl-1 ${
                    isMets
                      ? "text-theme-secondary bg-theme-bg-alt"
                      : "text-theme-primary bg-theme-card"
                  }`}
                >
                  {team.team}
                </span>
                <span className="w-10 text-center font-mono font-bold text-theme-text">
                  {team.w}
                </span>
                <span className="w-10 text-center font-mono font-bold text-theme-text">
                  {team.l}
                </span>
                <span className="w-14 text-center font-mono font-bold text-theme-muted text-xs">
                  {team.pct}
                </span>
                <span className="w-14 text-center font-mono font-black text-theme-primary text-xs">
                  {type === "division" ? team.gb : team.wcgb}
                </span>
                {type === "division" && (
                  <div className="contents">
                    <span className="w-12 text-center font-mono font-bold text-theme-muted text-xs">
                      {String(team.l10)}
                    </span>
                    <span className="w-12 text-center font-mono font-bold text-theme-muted text-xs">
                      {String(team.strk)}
                    </span>
                    <span
                      className={`w-12 text-center font-mono font-bold text-xs ${
                        String(team.diff || "").includes("+")
                          ? "text-green-600"
                          : "text-red-500"
                      }`}
                    >
                      {String(team.diff)}
                    </span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const ScheduleTab = ({
  fullCalendar,
  fullScheduleArray,
  openMedia,
  standings,
  nextGame,
  onPlayerClick,
}: any) => {
  const [view, setView] = useState("calendar"),
    [standingsSubView, setStandingsSubView] = useState("divisions"),
    [searchQuery, setSearchQuery] = useState("");
  const today = new Date(),
    currentYear = today.getFullYear(),
    currentMonth = today.getMonth(),
    currentDate = today.getDate();
  const [viewYear, setViewYear] = useState(currentYear),
    [viewMonth, setViewMonth] = useState(currentMonth),
    [selectedDay, setSelectedDay] = useState<number | null>(currentDate);
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate(),
    firstDayOfMonth = new Date(viewYear, viewMonth, 1).getDay();
  const calendarDays = Array.from({ length: daysInMonth }, (_, i) => i + 1),
    emptyDays = Array.from({ length: firstDayOfMonth }, (_, i) => i);
  const selectedDateKey = `${viewYear}-${String(viewMonth + 1).padStart(
    2,
    "0"
  )}-${String(selectedDay).padStart(2, "0")}`;
  const selectedGame = selectedDay ? fullCalendar[selectedDateKey] : null;
  const filteredSchedule = (fullScheduleArray || []).filter((game: any) =>
    game.opponent?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    if (view === "schedule" && nextGame && !searchQuery) {
      const timer = setTimeout(() => {
        const el = document.getElementById(`list-game-${nextGame.id}`);
        const container = document.getElementById("main-scroll-container");
        if (el && container) {
          container.scrollTo({
            top: Math.max(0, el.offsetTop - 120),
            behavior: "smooth",
          });
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [view, nextGame, searchQuery]);

  return (
    <div>
      <div className="bg-theme-primary px-3 sm:px-4 py-3 flex flex-wrap justify-center gap-2 shadow-md sticky top-[58px] z-20 border-b-4 border-theme-secondary">
        <PillButton
          label="CALENDAR"
          isActive={view === "calendar"}
          onClick={() => setView("calendar")}
        />
        <PillButton
          label="LIST"
          isActive={view === "schedule"}
          onClick={() => setView("schedule")}
        />
        <PillButton
          label="STANDINGS"
          isActive={view === "standings"}
          onClick={() => setView("standings")}
        />
      </div>
      {view === "standings" && (
        <div className="bg-theme-bg-alt border-b-2 border-theme-primary px-4 py-2 flex flex-wrap justify-center gap-4 shadow-sm sticky top-[100px] z-10">
          <button
            onClick={() => setStandingsSubView("divisions")}
            className={`text-[10px] font-black tracking-widest uppercase pb-1 border-b-2 transition-colors font-sans ${
              standingsSubView === "divisions"
                ? "border-theme-secondary text-theme-primary"
                : "border-transparent text-theme-muted hover:text-theme-primary"
            }`}
          >
            MLB Divisions
          </button>
          <button
            onClick={() => setStandingsSubView("wildcard")}
            className={`text-[10px] font-black tracking-widest uppercase pb-1 border-b-2 transition-colors font-sans ${
              standingsSubView === "wildcard"
                ? "border-theme-secondary text-theme-primary"
                : "border-transparent text-theme-muted hover:text-theme-primary"
            }`}
          >
            Wild Card Race
          </button>
        </div>
      )}
      <div className="p-4">
        {view === "calendar" && (
          <div className="space-y-4">
            <div className={cardStyle}>
              <div className="bg-theme-primary p-3 flex justify-between items-center border-b-2 border-theme-secondary">
                <ChevronLeft
                  className="text-white hover:text-theme-secondary cursor-pointer transition-colors"
                  size={24}
                  onClick={() => {
                    if (viewMonth === 0) {
                      setViewMonth(11);
                      setViewYear(viewYear - 1);
                    } else setViewMonth(viewMonth - 1);
                    setSelectedDay(null);
                  }}
                />
                <span className="text-white font-black font-theme-head text-xl tracking-widest uppercase">
                  {monthNames[viewMonth]} {viewYear}
                </span>
                <ChevronRight
                  className="text-white hover:text-theme-secondary cursor-pointer transition-colors"
                  size={24}
                  onClick={() => {
                    if (viewMonth === 11) {
                      setViewMonth(0);
                      setViewYear(viewYear + 1);
                    } else setViewMonth(viewMonth + 1);
                    setSelectedDay(null);
                  }}
                />
              </div>
              <div className="grid grid-cols-7 border-l-2 border-t-2 border-theme-primary bg-theme-bg">
                {["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map((d) => (
                  <div
                    key={d}
                    className="bg-theme-card text-theme-primary text-[9px] font-black text-center py-1.5 border-b-2 border-r-2 border-theme-primary font-sans"
                  >
                    {d}
                  </div>
                ))}
                {emptyDays.map((i) => (
                  <div
                    key={`empty-${i}`}
                    className="h-[72px] border-b-2 border-r-2 border-theme-primary bg-theme-bg-alt opacity-50"
                  ></div>
                ))}
                {calendarDays.map((day) => {
                  const isSelected = selectedDay === day,
                    isToday =
                      viewYear === currentYear &&
                      viewMonth === currentMonth &&
                      day === currentDate;
                  const dateKey = `${viewYear}-${String(viewMonth + 1).padStart(
                      2,
                      "0"
                    )}-${String(day).padStart(2, "0")}`,
                    game = fullCalendar[dateKey];
                  return (
                    <div
                      key={day}
                      onClick={() => setSelectedDay(day)}
                      className={`h-[72px] border-b-2 border-r-2 border-theme-primary p-1 flex flex-col relative transition-colors ${
                        isToday
                          ? "bg-theme-secondary/10 shadow-[inset_0_0_0_3px_var(--c-secondary)] z-10"
                          : isSelected
                          ? "bg-theme-secondary bg-opacity-20"
                          : "bg-theme-card"
                      } ${
                        game
                          ? "cursor-pointer hover:opacity-80"
                          : "cursor-pointer opacity-60 hover:opacity-100"
                      }`}
                    >
                      <span
                        className={`text-[10px] absolute top-1 left-1.5 font-mono ${
                          isToday
                            ? "bg-theme-secondary text-white px-1.5 py-0.5 font-black leading-none shadow-[1px_1px_0_0_var(--c-primary)]"
                            : isSelected
                            ? "font-bold text-theme-secondary"
                            : "font-bold text-theme-primary"
                        }`}
                      >
                        {day}
                      </span>
                      {game && (
                        <div className="flex flex-col items-center justify-center h-full pt-3">
                          <div
                            className={`w-[26px] h-[26px] rounded-full border-2 border-theme-primary flex items-center justify-center font-black font-theme-head text-[11px] shadow-[1px_1px_0_0_var(--c-border-primary)] ${
                              game.isHome
                                ? "bg-theme-secondary text-white border-theme-secondary"
                                : "bg-theme-card text-theme-primary"
                            }`}
                          >
                            {game.logo}
                          </div>
                          <span className="text-[8px] font-bold uppercase mt-1 tracking-tighter text-theme-primary leading-none text-center font-sans truncate w-full px-0.5">
                            {String(game.opponent).substring(0, 3)}
                          </span>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
            {selectedGame ? (
              ["Final", "Game Over", "Completed Early"].includes(
                selectedGame.status
              ) ? (
                <div className="animate-in fade-in slide-in-from-bottom-2">
                  <PastGameCard
                    key={`sc-${selectedGame.id}`}
                    game={selectedGame}
                    dateString={`${monthNames[viewMonth]} ${selectedDay}, ${viewYear}`}
                    title="Game Summary"
                    openMedia={openMedia}
                    onPlayerClick={onPlayerClick}
                  />
                </div>
              ) : (
                <div className="animate-in fade-in slide-in-from-bottom-2">
                  <GamecastCard
                    key={`sc-${selectedGame.id}`}
                    game={selectedGame}
                    openMedia={openMedia}
                    onPlayerClick={onPlayerClick}
                  />
                </div>
              )
            ) : (
              <div className="p-4 text-center text-theme-muted font-bold font-sans uppercase tracking-widest text-[10px]">
                No Game Scheduled
              </div>
            )}
          </div>
        )}
        {view === "schedule" && (
          <div className="space-y-4">
            <div className="relative mb-2">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Search size={16} className="text-theme-secondary" />
              </div>
              <input
                type="text"
                placeholder="Search opponents..."
                value={searchQuery}
                onChange={(e: any) => setSearchQuery(e.target.value)}
                className="w-full bg-theme-card border-2 border-theme-primary text-theme-text p-2.5 pl-9 text-xs font-black font-sans uppercase tracking-wider placeholder:text-theme-muted shadow-[inset_2px_2px_5px_rgba(0,0,0,0.05)] focus:outline-none focus:border-theme-secondary transition-colors"
              />
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery("")}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-theme-muted hover:text-theme-primary transition-colors"
                >
                  <X size={16} />
                </button>
              )}
            </div>
            {filteredSchedule.length > 0 ? (
              <div className="flex flex-col">
                {filteredSchedule.map((game: any) => {
                  const isPast = [
                    "Final",
                    "Game Over",
                    "Completed Early",
                  ].includes(game.status);
                  return (
                    <div key={`li-${game.id}`} id={`list-game-${game.id}`}>
                      {isPast ? (
                        <PastGameCard
                          game={game}
                          dateString={game.date}
                          title=""
                          openMedia={openMedia}
                          onPlayerClick={onPlayerClick}
                        />
                      ) : (
                        <GamecastCard
                          game={game}
                          openMedia={openMedia}
                          onPlayerClick={onPlayerClick}
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="text-center p-6 bg-theme-bg-alt border-2 border-dashed border-theme-primary text-theme-primary font-bold font-sans uppercase tracking-widest text-[10px]">
                No matching games found.
              </div>
            )}
          </div>
        )}
        {view === "standings" && (
          <div className="space-y-6">
            {(standings?.divisions || []).map((div: any) => (
              <StandingsTable key={div.name} data={div} type="division" />
            ))}
            {(standings?.wildcards || []).map((wc: any) => (
              <StandingsTable key={wc.name} data={wc} type="wildcard" />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const TeamTab = ({ roster, onPlayerClick }: any) => {
  const [view, setView] = useState("lineup");
  const hitters = roster?.hitters || [];
  const pitchers = roster?.pitchers || [];

  return (
    <div className="flex flex-col h-full">
      <div className="bg-theme-primary px-3 py-3 flex gap-1.5 shadow-md sticky top-[58px] z-20 border-b-4 border-theme-secondary">
        <PillButton
          label="LINEUP"
          isActive={view === "lineup"}
          onClick={() => setView("lineup")}
        />
        <PillButton
          label="HITTERS"
          isActive={view === "hitters"}
          onClick={() => setView("hitters")}
        />
        <PillButton
          label="PITCHERS"
          isActive={view === "pitchers"}
          onClick={() => setView("pitchers")}
        />
        <PillButton
          label="WALK-UPS"
          isActive={view === "walkups"}
          onClick={() => setView("walkups")}
        />
      </div>
      <div className="p-4">
        {view === "lineup" && (
          <div className={cardStyle}>
            <div className="bg-theme-primary p-3 border-b-2 border-theme-secondary text-xs font-bold text-white uppercase tracking-widest text-center font-sans">
              Today's Line Card
            </div>
            {hitters.slice(0, 9).map((p: any, idx: number) => (
              <div
                key={`lu-${p.num}`}
                onClick={() => onPlayerClick(p)}
                className={`flex items-center p-3 ${
                  idx !== 8 ? innerBorderStyle : ""
                } bg-theme-card hover:bg-theme-bg-alt cursor-pointer transition-colors`}
              >
                <span className="w-8 text-center text-sm font-black font-mono text-theme-secondary mr-2">
                  {idx + 1}.
                </span>
                <span className="w-8 text-xs font-bold text-theme-primary font-sans">
                  {p.pos}
                </span>
                <span className="font-black font-theme-head text-lg text-theme-primary uppercase tracking-wide">
                  {p.name}
                </span>
                <span className="ml-auto text-xs font-bold font-mono text-theme-muted border border-theme-muted px-1">
                  #{p.num}
                </span>
              </div>
            ))}
            <div
              onClick={() => onPlayerClick(pitchers[0])}
              className="bg-theme-secondary p-3 text-white flex justify-between items-center text-sm border-t-4 border-theme-primary cursor-pointer hover:opacity-90"
            >
              <span className="font-black font-sans uppercase tracking-widest text-[10px]">
                Starting Pitcher
              </span>
              <span className="font-bold font-theme-head">
                {pitchers[0]?.name || "TBD"}{" "}
                <span className="font-mono text-[10px] ml-1 opacity-80">
                  (#{pitchers[0]?.num || "-"})
                </span>
              </span>
            </div>
          </div>
        )}
        {view === "hitters" && (
          <div className={cardStyle}>
            <div className="overflow-x-auto">
              <div className="min-w-[650px]">
                <div className="bg-theme-primary p-2 text-[10px] font-bold text-white uppercase tracking-widest flex border-b-2 border-theme-secondary font-sans">
                  <span className="w-32 sticky left-0 bg-theme-primary z-10">
                    Player
                  </span>
                  <span className="w-12 text-center">AVG</span>
                  <span className="w-12 text-center">OPS</span>
                  <span className="w-10 text-center">HR</span>
                  <span className="w-10 text-center">RBI</span>
                </div>
                {hitters.map((p: any) => (
                  <div
                    key={`h-${p.num}`}
                    onClick={() => onPlayerClick(p)}
                    className="flex items-center p-2 text-sm border-b-2 border-theme-bg bg-theme-card hover:bg-theme-bg-alt cursor-pointer"
                  >
                    <div className="w-32 sticky left-0 bg-inherit z-10 pl-1 flex flex-col justify-center border-r border-theme-bg">
                      <span className="font-black font-theme-head text-theme-primary uppercase truncate pr-2">
                        {p.name}
                      </span>
                      <span className="text-[9px] text-theme-secondary font-bold font-sans">
                        {p.pos} • <span className="font-mono">#{p.num}</span>
                      </span>
                    </div>
                    <span className="w-12 text-center font-mono text-sm text-theme-primary font-black">
                      {p.avg}
                    </span>
                    <span className="w-12 text-center font-mono text-sm text-theme-primary font-black">
                      {p.ops}
                    </span>
                    <span className="w-10 text-center font-mono text-sm text-theme-text font-bold">
                      {p.hr}
                    </span>
                    <span className="w-10 text-center font-mono text-sm text-theme-text font-bold">
                      {p.rbi}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {view === "pitchers" && (
          <div className={cardStyle}>
            <div className="overflow-x-auto">
              <div className="min-w-[550px]">
                <div className="bg-theme-primary p-2 text-[10px] font-bold text-white uppercase tracking-widest flex border-b-2 border-theme-secondary font-sans">
                  <span className="w-32 sticky left-0 bg-theme-primary z-10">
                    Player
                  </span>
                  <span className="w-12 text-center">ERA</span>
                  <span className="w-12 text-center">WHIP</span>
                  <span className="w-10 text-center">W</span>
                </div>
                {pitchers.map((p: any) => (
                  <div
                    key={`p-${p.num}`}
                    onClick={() => onPlayerClick(p)}
                    className="flex items-center p-2 text-sm border-b-2 border-theme-bg bg-theme-card hover:bg-theme-bg-alt cursor-pointer"
                  >
                    <div className="w-32 sticky left-0 bg-inherit z-10 pl-1 flex flex-col justify-center border-r border-theme-bg">
                      <span className="font-black font-theme-head text-theme-primary uppercase truncate pr-2">
                        {p.name}
                      </span>
                      <span className="text-[9px] text-theme-secondary font-bold font-sans">
                        {p.pos} • <span className="font-mono">#{p.num}</span>
                      </span>
                    </div>
                    <span className="w-12 text-center font-mono text-sm text-theme-primary font-black">
                      {p.era}
                    </span>
                    <span className="w-12 text-center font-mono text-sm text-theme-primary font-black">
                      {p.whip}
                    </span>
                    <span className="w-10 text-center font-mono text-sm text-theme-text font-bold">
                      {p.w}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {view === "walkups" && (
          <div className={cardStyle}>
            <div className="bg-theme-primary p-3 border-b-2 border-theme-secondary text-xs font-bold text-white uppercase tracking-widest flex justify-between items-center font-sans">
              <span>Walk-Up Songs</span>
              <span className="bg-theme-secondary font-mono text-white px-2 py-0.5 text-[9px] border border-white/30">
                2026
              </span>
            </div>
            {[...hitters, ...pitchers].map((p: any, idx: number) => (
              <div
                key={`w-${p.num}`}
                onClick={() => onPlayerClick(p)}
                className={`p-3 flex items-center ${
                  idx !== 0 ? innerBorderStyle : ""
                } bg-theme-card hover:bg-theme-bg-alt cursor-pointer`}
              >
                <div className="w-10 h-10 border-2 border-theme-primary bg-theme-bg-alt flex items-center justify-center mr-3 flex-shrink-0 relative shadow-[2px_2px_0_0_var(--c-border-primary)]">
                  <span className="text-xs font-black font-mono text-theme-primary">
                    {p.num}
                  </span>
                </div>
                <div className="flex-1 overflow-hidden">
                  <p className="text-sm font-black font-theme-head text-theme-primary uppercase">
                    {p.name}
                  </p>
                  <p className="text-[11px] font-bold text-theme-muted font-sans truncate mt-0.5">
                    {p.walkUp || "Not Available"}
                  </p>
                </div>
                <Music
                  size={16}
                  className="text-theme-secondary ml-2 flex-shrink-0"
                />
              </div>
            ))}
          </div>
        )}

        <div className="w-full flex justify-center pt-8 pb-4">
          <div className="opacity-50 text-3xl cursor-default select-none transition-all duration-300 hover:opacity-100 hover:-translate-y-2 hover:scale-110">
            🤠
          </div>
        </div>
      </div>
    </div>
  );
};

const NewsTab = ({ openMedia, liveNews }: any) => {
  const safeNews = liveNews || [];
  const [randomArticle] = useState(() => {
    const daysSinceEpoch = Math.floor(Date.now() / (1000 * 60 * 60 * 24));
    return VINTAGE_ARTICLES[daysSinceEpoch % VINTAGE_ARTICLES.length];
  });

  return (
    <div className="p-4 space-y-8">
      <section>
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center space-x-2">
            <div className="w-2 h-2 bg-theme-secondary animate-pulse border border-theme-primary"></div>
            <h2 className={labelStyle + " text-[14px]"}>Live News Wire</h2>
          </div>
        </div>
        <div className="space-y-4">
          {safeNews.map((blog: any) => (
            <div
              key={blog.id}
              className={`${cardStyle} p-4 cursor-pointer hover:bg-theme-bg`}
              onClick={() =>
                openMedia({
                  type: "article",
                  title: blog.title,
                  source: blog.source,
                  link: blog.link,
                  content: blog.content,
                })
              }
            >
              <div className="flex justify-between items-start mb-2">
                <span className={labelStyle}>{blog.source}</span>
                <span className="text-[10px] font-bold text-theme-muted font-sans uppercase">
                  {blog.time}
                </span>
              </div>
              <h3 className="text-md font-bold font-theme-head text-theme-primary leading-snug">
                {blog.title}
              </h3>
            </div>
          ))}
          {safeNews.length === 0 && (
            <div className="p-4 text-center text-theme-muted font-bold font-sans uppercase tracking-widest text-[10px]">
              No news available.
            </div>
          )}
        </div>
      </section>

      {randomArticle && (
        <section>
          <div className="flex items-center space-x-2 mb-3">
            <div className="w-2 h-2 bg-theme-secondary border border-theme-primary"></div>
            <h2 className={labelStyle + " text-[14px] flex items-center"}>
              <BookOpen size={16} className="mr-1.5" /> From The Archives
            </h2>
          </div>
          <div
            className={`${cardStyle} bg-theme-bg-alt p-5 relative overflow-hidden`}
          >
            <div className="border-b-4 border-double border-theme-primary pb-3 mb-3">
              <p
                className={
                  labelStyle + " text-center mb-1 text-theme-secondary"
                }
              >
                {randomArticle.publication}
              </p>
              <h3 className="text-xl font-black font-theme-head text-theme-primary leading-none text-center uppercase text-balance">
                {randomArticle.headline}
              </h3>
              <p className="text-[9px] font-bold font-sans text-theme-muted uppercase tracking-widest text-center mt-2">
                {randomArticle.date}
              </p>
            </div>
            <p className="text-sm font-theme-head text-theme-text leading-relaxed mb-5 text-justify">
              <span className="float-left text-5xl leading-none font-black text-theme-primary mr-1 mt-1 pr-1 border-r-2 border-theme-secondary">
                {randomArticle.snippet.charAt(0)}
              </span>
              {randomArticle.snippet.slice(1)}
            </p>
            <button
              onClick={() =>
                openMedia({
                  type: "article",
                  title: randomArticle.headline,
                  source: randomArticle.publication,
                  link: randomArticle.link,
                  content: `<p class="text-xl italic">"${randomArticle.snippet}"</p><hr class="my-6 border-gray-300"/><p class="text-sm text-gray-500"><strong>Note:</strong> This is a historical snippet from the archives.</p>`,
                })
              }
              className="w-full bg-theme-primary text-white font-sans py-2.5 text-[10px] font-black tracking-widest uppercase border-2 border-theme-secondary shadow-[2px_2px_0_0_var(--c-secondary)] hover:opacity-90 active:translate-y-[2px] active:shadow-none transition-all"
            >
              Read Full Clipping
            </button>
          </div>
        </section>
      )}

      <div className="w-full flex justify-center pt-8 pb-4">
        <div className="opacity-50 text-3xl cursor-default select-none transition-all duration-300 hover:opacity-100 hover:-translate-y-2 hover:scale-110">
          ⚾
        </div>
      </div>
    </div>
  );
};

export default function MetsApp() {
  const [activeTab, setActiveTab] = useState<string>("home");
  const [activeMedia, setActiveMedia] = useState<any>(null);
  const [activeTheme, setActiveTheme] = useState<string>(() => {
    const themeKeys = Object.keys(THEMES);
    const daysSinceEpoch = Math.floor(Date.now() / (1000 * 60 * 60 * 24));
    return themeKeys[daysSinceEpoch % themeKeys.length];
  });
  const [showThemeModal, setShowThemeModal] = useState(false);
  const [liveNews, setLiveNews] = useState<any[]>([]);
  const [fullScheduleArray, setFullScheduleArray] = useState<any[]>([]);
  const [fullCalendar, setFullCalendar] = useState<any>({});
  const [roster, setRoster] = useState<any>({ hitters: [], pitchers: [] });
  const [standings, setStandings] = useState<any>({
    divisions: [],
    wildcards: [],
  });
  const [nextGame, setNextGame] = useState<any>(null);
  const [lastGame, setLastGame] = useState<any>(null);
  const [connectionStatus, setConnectionStatus] = useState("connecting");
  const [isLoading, setIsLoading] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);

  // Shared Player Modal State
  const [selectedPlayer, setSelectedPlayer] = useState<any>(null);
  const [playerHighlights, setPlayerHighlights] = useState<any[]>([]);
  const [isLoadingPlayer, setIsLoadingPlayer] = useState(false);

  const handleScroll = (e: any) => setIsScrolled(e.target.scrollTop > 15);

  const openPlayerModal = (playerOrName: any) => {
    if (!playerOrName) return;
    if (typeof playerOrName === "string") {
      const allMets = [...roster.hitters, ...roster.pitchers];
      const cleanName = playerOrName.replace(/[,.]/g, "").trim();
      const nameParts = cleanName.split(" ").filter(Boolean);
      if (nameParts.length === 0) return;
      const lastName = nameParts[nameParts.length - 1].toLowerCase();

      // Check if the clicked string matches any of our players' last names
      const found = allMets.find((p: any) =>
        p.name.toLowerCase().includes(lastName)
      );
      if (found) setSelectedPlayer(found);
    } else {
      setSelectedPlayer(playerOrName);
    }
  };

  useEffect(() => {
    if (!selectedPlayer) {
      setPlayerHighlights([]);
      return;
    }
    let isMounted = true;
    const fetchPlayerExtras = async () => {
      setIsLoadingPlayer(true);
      try {
        const pRes = await fetch(
          `https://statsapi.mlb.com/api/v1/people/${selectedPlayer.id}?hydrate=stats(type=[gameLog])`
        );
        const pData = await pRes.json();
        const gameLogs =
          pData.people?.[0]?.stats?.find(
            (s: any) => s.type.displayName === "gameLog"
          )?.splits || [];

        const gamePks = Array.from(
          new Set(gameLogs.map((s: any) => s.game.gamePk))
        )
          .reverse()
          .slice(0, 4);

        let foundHighlights: any[] = [];
        const lastName = String(selectedPlayer.name).split(" ").pop() || "";

        for (let pk of gamePks) {
          const cRes = await fetch(
            `https://statsapi.mlb.com/api/v1/game/${pk}/content`
          ).then((r) => r.json());
          const hls = cRes.highlights?.highlights?.items || [];
          const playerHls = hls.filter(
            (h: any) =>
              String(h.headline || "")
                .toLowerCase()
                .includes(lastName.toLowerCase()) ||
              String(h.description || "")
                .toLowerCase()
                .includes(lastName.toLowerCase())
          );
          foundHighlights = [...foundHighlights, ...playerHls];
        }

        const uniqueHls = Array.from(
          new Map(
            foundHighlights.map((item) => [item.mediaPlaybackId, item])
          ).values()
        );
        const parsedHls = uniqueHls
          .map((item: any, idx: number) => {
            const mp4 =
              item.playbacks?.find((p: any) => p.url?.includes(".mp4")) ||
              item.playbacks?.[0];
            return {
              id: item.mediaPlaybackId || idx,
              title: item.headline,
              duration: item.duration || "",
              videoUrl: mp4?.url,
            };
          })
          .filter((h: any) => h.videoUrl);

        if (isMounted) setPlayerHighlights(parsedHls);
      } catch (e) {}
      if (isMounted) setIsLoadingPlayer(false);
    };
    fetchPlayerExtras();
    return () => {
      isMounted = false;
    };
  }, [selectedPlayer]);

  useEffect(() => {
    const y = new Date().getFullYear();

    const fetchNews = async () => {
      try {
        const rssFeeds = [
          {
            source: "Amazin' Avenue",
            url: "https://www.amazinavenue.com/rss/current.xml",
          },
          { source: "Metsmerized", url: "https://metsmerizedonline.com/feed/" },
          {
            source: "NY Post",
            url: "https://nypost.com/tag/new-york-mets/feed/",
          },
          { source: "SNY", url: "https://sny.tv/rss/mets" },
        ];

        const feedPromises = rssFeeds.map(async (feed) => {
          try {
            const res = await fetch(
              `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(
                feed.url
              )}`
            );
            const data = await res.json();
            if (data.status === "ok") {
              return data.items.map((item: any) => ({
                source: feed.source,
                title: String(item.title || ""),
                timeRaw: new Date(
                  item.pubDate ? item.pubDate.replace(/-/g, "/") : Date.now()
                ).getTime(),
                time: new Date(
                  item.pubDate ? item.pubDate.replace(/-/g, "/") : Date.now()
                ).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  hour: "numeric",
                  minute: "2-digit",
                }),
                link: String(item.link || ""),
                content: String(item.content || item.description || ""),
              }));
            }
            return [];
          } catch (e) {
            return [];
          }
        });

        const allFeeds = await Promise.all(feedPromises);
        const combinedNews = allFeeds
          .flat()
          .sort((a, b) => b.timeRaw - a.timeRaw)
          .map((item, idx) => ({ ...item, id: idx }))
          .slice(0, 15);

        setLiveNews(combinedNews);
      } catch (e) {
        console.error("News fetch error", e);
      }
    };

    const fetchStandingsData = async () => {
      try {
        const stdRes = await fetch(
          `https://statsapi.mlb.com/api/v1/standings?leagueId=103,104&season=${y}&standingsTypes=regularSeason,wildCard`
        ).then((r) => r.json());

        const divMap: any = {
          201: "AL East",
          202: "AL Central",
          200: "AL West",
          204: "NL East",
          205: "NL Central",
          203: "NL West",
        };
        const wcMap: any = { 103: "AL Wild Card", 104: "NL Wild Card" };

        const divs: any[] = [];
        const wcs: any[] = [];

        stdRes.records?.forEach((r: any) => {
          if (r.standingsType === "regularSeason" && divMap[r.division.id]) {
            divs.push({
              id: r.division.id,
              name: divMap[r.division.id],
              teams: r.teamRecords.map((t: any) => ({
                team: t.team.name,
                w: t.wins,
                l: t.losses,
                pct: t.winningPercentage,
                gb: t.gamesBack,
                l10:
                  t.records?.splitRecords?.find(
                    (sr: any) => sr.type === "lastTen"
                  )?.pct || "-",
                strk: t.streak?.streakCode || "-",
                diff: t.runDifferential || "-",
              })),
            });
          } else if (r.standingsType === "wildCard" && wcMap[r.league.id]) {
            wcs.push({
              id: r.league.id,
              name: wcMap[r.league.id],
              teams: r.teamRecords.map((t: any) => ({
                team: t.team.name,
                w: t.wins,
                l: t.losses,
                pct: t.winningPercentage,
                wcgb: t.wildCardGamesBack,
              })),
            });
          }
        });

        // Sort to standard order
        const divOrder = [201, 202, 200, 204, 205, 203];
        divs.sort((a, b) => divOrder.indexOf(a.id) - divOrder.indexOf(b.id));
        wcs.sort((a, b) => a.id - b.id);

        setStandings({ divisions: divs, wildcards: wcs });
      } catch (e) {
        console.error("Standings fetch error", e);
      }
    };

    const fetchTeamData = async () => {
      try {
        const fetchWalkupDB = async () => {
          const walkupMap: any = {
            "Francisco Lindor": "My Girl - The Temptations",
            "Pete Alonso": "Working Man - Rush",
            "Brandon Nimmo": "Following The Sun - SUPER-Hi",
            "Starling Marte": "El Gogo - El Alfa",
            "Jeff McNeil": "The Wolf - The Spencer Lee Band",
            "Francisco Alvarez": "La Mama de la Mama - El Alfa",
            "Mark Vientos": "El Rey - Romeo Santos",
            "Edwin Díaz": "Narco - Blasterjaxx & Timmy Trumpet",
            "Edwin Diaz": "Narco - Blasterjaxx & Timmy Trumpet",
            "Harrison Bader": "Hustlin' - Rick Ross",
            "Brett Baty": "Hate It Or Love It - 50 Cent",
            "Luis Severino": "Fire Squad - J. Cole",
            "Jose Quintana": "Eladio Carrion - Kemba Walker",
            "J.D. Martinez": "Hustlin' - Rick Ross",
            "Tyrone Taylor": "Murder on My Mind - YNW Melly",
            "Sean Manaea": "Ghost - Justin Bieber",
            "Kodai Senga": "Ghost - Justin Bieber",
          };
          try {
            const res = await fetch(
              `https://api.allorigins.win/get?url=${encodeURIComponent(
                "https://walkupdb.com/teams/new-york-mets"
              )}`
            );
            const data = await res.json();
            const doc = new DOMParser().parseFromString(
              data.contents,
              "text/html"
            );
            const rows = doc.querySelectorAll("tr");
            rows.forEach((row) => {
              const cells = row.querySelectorAll("td");
              if (cells.length >= 2) {
                const pName = cells[0].textContent?.trim();
                const pSong = cells[1].textContent?.trim();
                if (pName && pSong) walkupMap[pName] = pSong;
              }
            });
          } catch (e) {
            console.warn(
              "Live WalkupDB scrape failed, using verified snapshot.",
              e
            );
          }
          return walkupMap;
        };

        const walkupData = await fetchWalkupDB();

        const rRes = await fetch(
          `https://statsapi.mlb.com/api/v1/teams/121/roster?season=${y}&hydrate=person(stats(type=season))`
        ).then((r) => r.json());

        const h: any[] = [],
          p: any[] = [];
        rRes.roster?.forEach((member: any) => {
          const stats = member.person.stats?.[0]?.splits?.[0]?.stat || {};
          const playerName = member.person.fullName;

          let song = walkupData[playerName];
          if (!song) {
            const lastName = playerName.split(" ").pop();
            const match = Object.keys(walkupData).find((k) =>
              k.includes(lastName || "")
            );
            if (match) song = walkupData[match];
          }

          const obj = {
            id: member.person.id,
            num: member.jerseyNumber || "--",
            name: playerName,
            pos: member.position.abbreviation,
            age: member.person.currentAge || "-",
            height: member.person.height || "-",
            weight: member.person.weight ? `${member.person.weight} lbs` : "-",
            bats: member.person.batSide?.code || "-",
            throws: member.person.pitchHand?.code || "-",
            avg: stats.avg || ".---",
            obp: stats.obp || ".---",
            slg: stats.slg || ".---",
            ops: stats.ops || ".---",
            hr: stats.homeRuns || "0",
            rbi: stats.rbi || "0",
            hits: stats.hits || "0",
            runs: stats.runs || "0",
            sb: stats.stolenBases || "0",
            doubles: stats.doubles || "0",
            triples: stats.triples || "0",
            bb: stats.baseOnBalls || "0",
            so: stats.strikeOuts || "0",
            g: stats.gamesPlayed || "0",
            ab: stats.atBats || "0",
            era: stats.era || "-.--",
            whip: stats.whip || "-.--",
            w: stats.wins || "0",
            l: stats.losses || "0",
            ip: stats.inningsPitched || "0.0",
            sv: stats.saves || "0",
            gs: stats.gamesStarted || "0",
            cg: stats.completeGames || "0",
            sho: stats.shutouts || "0",
            hrAllowed: stats.homeRuns || "0",
            hometown: member.person.birthCity
              ? `${member.person.birthCity}, ${
                  member.person.birthStateProvince || member.person.birthCountry
                }`
              : "Unknown",
            walkUp: song || null,
            contract: "Active Roster",
          };
          if (member.position.type === "Pitcher") p.push(obj);
          else h.push(obj);
        });
        setRoster({ hitters: h, pitchers: p });
      } catch (e) {
        console.error("Team fetch error", e);
      }
    };

    const fetchScheduleData = async () => {
      setIsLoading(true);
      try {
        const schedRes = await fetch(
          `https://statsapi.mlb.com/api/v1/schedule?sportId=1&teamId=121&season=${y}&gameType=R,S,E,W,A,F,D,L&hydrate=linescore,decisions,probablePitcher,person,stats`
        ).then((r) => {
          if (!r.ok) throw new Error("API Failure");
          return r.json();
        });

        const schedArr: any[] = [];
        const calDict: any = {};

        schedRes.dates?.forEach((d: any) => {
          d.games.forEach((g: any) => {
            if (g.teams.home.team.id === 121 || g.teams.away.team.id === 121) {
              const isHome = g.teams.home.team.id === 121,
                mets = isHome ? g.teams.home : g.teams.away,
                opp = isHome ? g.teams.away.team : g.teams.home.team;
              const gData: any = {
                id: g.gamePk,
                rawDate: g.gameDate,
                opponent: opp.name.replace("New York", "NY"),
                logo: opp.name.charAt(0),
                date: new Date(g.gameDate).toLocaleDateString("en-US", {
                  weekday: "short",
                  month: "short",
                  day: "numeric",
                }),
                time: new Date(g.gameDate).toLocaleTimeString("en-US", {
                  hour: "numeric",
                  minute: "2-digit",
                }),
                isHome,
                venue: g.venue.name,
                tv: "SNY",
                radio: "WCBS",
                uniform: predictMetsUniform(g.gameDate, isHome),
                status: g.status.abstractGameState,
                metsScore: mets.score || 0,
                oppScore: isHome
                  ? g.teams.away.score || 0
                  : g.teams.home.score || 0,
                probablePitcherAway:
                  g.teams.away.probablePitcher?.fullName || "TBD",
                probablePitcherAwayEra:
                  g.teams.away.probablePitcher?.stats?.[0]?.splits?.[0]?.stat
                    ?.era ?? null,
                probablePitcherHome:
                  g.teams.home.probablePitcher?.fullName || "TBD",
                probablePitcherHomeEra:
                  g.teams.home.probablePitcher?.stats?.[0]?.splits?.[0]?.stat
                    ?.era ?? null,
                lineScore: {
                  away: [0, 0],
                  home: [0, 0],
                  awayRHE: [0, 0, 0],
                  homeRHE: [0, 0, 0],
                },
              };

              const isFinal = [
                "Final",
                "Game Over",
                "Completed Early",
              ].includes(g.status.abstractGameState);
              if (isFinal) {
                gData.result =
                  mets.score >
                  (isHome ? g.teams.away.score : g.teams.home.score)
                    ? "W"
                    : "L";
                if (g.decisions) {
                  const parseName = (obj: any) =>
                    obj?.fullName?.split(" ").pop() ||
                    obj?.initLastName ||
                    "N/A";
                  gData.wp = parseName(g.decisions.winner);
                  gData.lp = parseName(g.decisions.loser);
                  gData.sv = g.decisions.save
                    ? parseName(g.decisions.save)
                    : null;
                }
              }

              if (g.linescore) {
                const lsAway: any[] = [],
                  lsHome: any[] = [];
                g.linescore.innings.forEach((i: any) => {
                  lsAway.push(i.away?.runs !== undefined ? i.away.runs : "");
                  let hr = i.home?.runs;
                  if (hr === undefined && isFinal && i.num >= 9) hr = "X";
                  else if (hr === undefined) hr = "";
                  lsHome.push(hr);
                });
                gData.lineScore = {
                  away: lsAway,
                  home: lsHome,
                  awayRHE: [
                    g.linescore.teams.away?.runs || 0,
                    g.linescore.teams.away?.hits || 0,
                    g.linescore.teams.away?.errors || 0,
                  ],
                  homeRHE: [
                    g.linescore.teams.home?.runs || 0,
                    g.linescore.teams.home?.hits || 0,
                    g.linescore.teams.home?.errors || 0,
                  ],
                };
                if (
                  g.status.abstractGameState === "Live" ||
                  g.status.abstractGameState === "In Progress"
                ) {
                  gData.inning = `${g.linescore.isTopInning ? "TOP" : "BOT"} ${
                    g.linescore.currentInning
                  }`;
                  gData.outs = g.linescore.outs;
                  gData.bases = {
                    first: !!g.linescore.offense.first,
                    second: !!g.linescore.offense.second,
                    third: !!g.linescore.offense.third,
                  };
                  gData.batter = g.linescore.offense.batter?.fullName;
                  gData.pitcher = g.linescore.defense.pitcher?.fullName;
                }
              }

              schedArr.push(gData);
              if (!calDict[d.date]) calDict[d.date] = gData;
            }
          });
        });

        if (schedArr.length === 0) throw new Error("No games found");

        const now = Date.now();
        const twelveHoursAgo = now - 12 * 60 * 60 * 1000;
        let lastG: any = null,
          nextG: any = null;

        schedArr.forEach((g) => {
          const isFinal = ["Final", "Game Over", "Completed Early"].includes(
            g.status
          );
          const isCancelled = ["Postponed", "Cancelled"].includes(g.status);
          const gameTime = new Date(g.rawDate).getTime();

          if (isFinal) {
            lastG = g;
          } else if (
            !nextG &&
            !isCancelled &&
            (gameTime > twelveHoursAgo ||
              ["Live", "In Progress", "Delayed", "Warmup"].includes(g.status))
          ) {
            nextG = g;
          }
        });

        setFullScheduleArray(schedArr);
        setFullCalendar(calDict);
        setLastGame(lastG);
        setNextGame(nextG);
        setConnectionStatus("live");
      } catch (e) {
        setConnectionStatus("error");
        setNextGame({
          id: 999999,
          opponent: "Atlanta Braves",
          logo: "A",
          date: "Tomorrow",
          time: "7:10 PM",
          isHome: true,
          venue: "Citi Field",
          tv: "SNY",
          radio: "WCBS",
          uniform: "Home Pinstripes",
          status: "Scheduled",
          metsScore: 0,
          oppScore: 0,
          probablePitcherAway: "M. Fried",
          probablePitcherAwayEra: "2.56",
          probablePitcherHome: "K. Senga",
          probablePitcherHomeEra: "2.98",
        });
        setLastGame({
          id: 999998,
          opponent: "Philadelphia Phillies",
          logo: "P",
          date: "Yesterday",
          time: "Final",
          isHome: false,
          venue: "Citizens Bank Park",
          tv: "SNY",
          radio: "WCBS",
          uniform: "Road Grey",
          status: "Final",
          metsScore: 5,
          oppScore: 3,
          wp: "Senga",
          lp: "Wheeler",
          sv: "Diaz",
          result: "W",
        });
      }
      setIsLoading(false);
    };

    // Trigger non-critical data fetches in the background
    fetchNews();
    fetchStandingsData();
    fetchTeamData();

    // Await the critical schedule data needed for the Home Tab
    fetchScheduleData();
  }, []);

  const t = THEMES[activeTheme];

  useEffect(() => {
    // Update the browser tab title
    if (
      nextGame &&
      (nextGame.status === "Live" || nextGame.status === "In Progress")
    ) {
      const metsScore = nextGame.metsScore || 0;
      const oppScore = nextGame.oppScore || 0;
      const oppName = String(nextGame.opponent).substring(0, 3).toUpperCase();
      document.title = `${
        nextGame.inning || "LIVE"
      } | NYM ${metsScore}, ${oppName} ${oppScore}`;
    } else {
      document.title = "Metropolitans Avenue";
    }

    // Generate a dynamic SVG favicon matching the theme colors
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect width="100" height="100" fill="${t.primary}" rx="20"/><text x="50" y="68" font-family="system-ui, sans-serif" font-style="italic" font-weight="900" font-size="50" fill="${t.secondary}" text-anchor="middle">NY</text></svg>`;
    const faviconUrl = "data:image/svg+xml;utf8," + encodeURIComponent(svg);

    let link: any = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = faviconUrl;
  }, [activeTheme, t, nextGame]);

  if (isLoading) {
    return (
      <div
        style={{
          backgroundColor: "#E5E0D8",
          height: "100dvh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "system-ui, -apple-system, sans-serif",
        }}
      >
        <style>{`
          @keyframes custom-bounce {
            0%, 100% { transform: translateY(-25%); animation-timing-function: cubic-bezier(0.8,0,1,1); }
            50% { transform: none; animation-timing-function: cubic-bezier(0,0,0.2,1); }
          }
          @keyframes custom-pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: .5; }
          }
        `}</style>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            marginBottom: "2rem",
            fontSize: "3rem",
            filter: "drop-shadow(0 4px 3px rgba(0,0,0,0.07))",
          }}
        >
          <div style={{ animation: "custom-bounce 1s infinite" }}>⚾</div>
          <div
            style={{
              animation: "custom-bounce 1s infinite",
              animationDelay: "0.15s",
            }}
          >
            🧢
          </div>
          <div
            style={{
              animation: "custom-bounce 1s infinite",
              animationDelay: "0.3s",
            }}
          >
            🌭
          </div>
          <div
            style={{
              animation: "custom-bounce 1s infinite",
              animationDelay: "0.45s",
            }}
          >
            🏟️
          </div>
        </div>
        <p
          style={{
            color: "#002D72",
            fontWeight: 900,
            textTransform: "uppercase",
            letterSpacing: "0.1em",
            fontSize: "0.75rem",
            animation: "custom-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
          }}
        >
          Warming up in the bullpen...
        </p>
      </div>
    );
  }

  return (
    <div className="bg-theme-bg h-[100dvh] font-sans flex justify-center transition-colors duration-300">
      <style>{`
        :root { --c-primary: ${t.primary}; --c-secondary: ${
        t.secondary
      }; --c-bg: ${t.bg}; --c-bg-alt: ${t.bgAlt}; --c-card: ${
        t.card
      }; --c-text: ${t.text}; --c-text-muted: ${
        t.textMuted
      }; --c-text-primary: ${t.textPrimary || t.primary}; --c-border-primary: ${
        t.borderPrimary || t.primary
      }; --f-head: ${t.fontHead}; }
        body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; }
        .font-theme-head { font-family: var(--f-head); }
        .font-mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace; font-variant-numeric: tabular-nums; }
        .bg-theme-primary { background-color: var(--c-primary); } .bg-theme-secondary { background-color: var(--c-secondary); }
        .bg-theme-bg { background-color: var(--c-bg); } .bg-theme-bg-alt { background-color: var(--c-bg-alt); }
        .bg-theme-card { background-color: var(--c-card); } .text-theme-primary { color: var(--c-text-primary); }
        .text-theme-secondary { color: var(--c-secondary); } .text-theme-text { color: var(--c-text); }
        .text-theme-muted { color: var(--c-text-muted); } .border-theme-primary { border-color: var(--c-border-primary); }
        .border-theme-secondary { border-color: var(--c-secondary); } .theme-pinstripes { background-image: ${
          t.pinstripes
        }; }
        .article-content { font-family: serif; color: var(--c-text); }
        .article-content img, .article-content figure { max-width: 100%; height: auto; margin: 16px 0; border: 2px solid var(--c-border-primary); }
        .article-content p { margin-bottom: 16px; line-height: 1.6; font-size: 15px;}
        .article-content a { color: var(--c-secondary); font-weight: bold; text-decoration: underline; }
        .article-content h1, .article-content h2, .article-content h3 { font-family: var(--f-head); font-weight: 900; margin: 24px 0 12px 0; color: var(--c-text-primary); font-size: 1.25rem;}
        .article-content ul, .article-content ol { margin-left: 20px; margin-bottom: 16px; }
        .article-content li { margin-bottom: 8px; }
      `}</style>
      <div className="w-full max-w-md bg-theme-bg-alt h-full shadow-2xl relative flex flex-col border-theme-primary overflow-hidden">
        <div
          id="main-scroll-container"
          className="flex-1 overflow-y-auto bg-theme-bg theme-pinstripes relative"
          onScroll={handleScroll}
        >
          <div
            className={`sticky top-0 z-50 transition-all border-b-4 border-theme-primary ${
              isScrolled ? "pt-1 pb-1 shadow-md backdrop-blur-md" : "pt-2 pb-2"
            }`}
          >
            <div
              className={`absolute inset-0 bg-theme-bg-alt theme-pinstripes transition-opacity ${
                isScrolled ? "opacity-90" : "opacity-100"
              }`}
            ></div>
            <div className="relative z-10 px-5 flex justify-between items-center">
              <StreetSignLogo isScrolled={isScrolled} />
              <div
                onClick={() => setShowThemeModal(true)}
                className="bg-theme-primary border-2 border-theme-secondary rounded-full p-2 cursor-pointer"
              >
                <Palette size={18} className="text-white" />
              </div>
            </div>
          </div>
          {activeTab === "home" && (
            <HomeTab
              openMedia={setActiveMedia}
              nextGame={nextGame}
              lastGame={lastGame}
              onPlayerClick={openPlayerModal}
            />
          )}
          {activeTab === "schedule" && (
            <ScheduleTab
              fullCalendar={fullCalendar}
              fullScheduleArray={fullScheduleArray}
              openMedia={setActiveMedia}
              standings={standings}
              nextGame={nextGame}
              onPlayerClick={openPlayerModal}
            />
          )}
          {activeTab === "team" && (
            <TeamTab
              openMedia={setActiveMedia}
              roster={roster}
              onPlayerClick={openPlayerModal}
            />
          )}
          {activeTab === "news" && (
            <NewsTab openMedia={setActiveMedia} liveNews={liveNews} />
          )}
        </div>
        <div className="border-t-4 border-theme-primary flex justify-around p-2 bg-theme-bg-alt relative">
          <div className="absolute top-0 left-0 w-full h-1 bg-theme-secondary"></div>
          <TabButton
            icon={<Home size={24} />}
            label="HOME"
            isActive={activeTab === "home"}
            onClick={() => setActiveTab("home")}
            isScrolled={isScrolled}
          />
          <TabButton
            icon={<Calendar size={24} />}
            label="GAMES"
            isActive={activeTab === "schedule"}
            onClick={() => setActiveTab("schedule")}
            isScrolled={isScrolled}
          />
          <TabButton
            icon={<Users size={24} />}
            label="TEAM"
            isActive={activeTab === "team"}
            onClick={() => setActiveTab("team")}
            isScrolled={isScrolled}
          />
          <TabButton
            icon={<Newspaper size={24} />}
            label="NEWS"
            isActive={activeTab === "news"}
            onClick={() => setActiveTab("news")}
            isScrolled={isScrolled}
          />
        </div>

        {showThemeModal && (
          <div className="fixed inset-0 bg-black/80 z-[110] flex items-center justify-center p-4">
            <div className="bg-theme-bg-alt w-full max-w-sm border-4 border-theme-primary shadow-[8px_8px_0_0_var(--c-secondary)] animate-in zoom-in-95">
              <div className="bg-theme-primary p-3 flex justify-between items-center border-b-4 border-theme-secondary">
                <span className="text-white font-bold font-theme-head text-lg tracking-widest uppercase">
                  Theme Selector
                </span>
                <button
                  onClick={() => setShowThemeModal(false)}
                  className="text-white hover:text-theme-secondary"
                >
                  <X size={20} />
                </button>
              </div>
              <div className="p-4 space-y-3 bg-theme-card">
                {Object.keys(THEMES).map((themeKey: string) => (
                  <div
                    key={themeKey}
                    onClick={() => {
                      setActiveTheme(themeKey);
                      setShowThemeModal(false);
                    }}
                    className={`p-3 border-2 cursor-pointer flex justify-between items-center transition-all ${
                      activeTheme === themeKey
                        ? "border-theme-secondary shadow-[4px_4px_0_0_var(--c-secondary)] bg-theme-bg"
                        : "border-gray-300 hover:border-theme-primary"
                    }`}
                  >
                    <span className="font-bold text-theme-text font-theme-head">
                      {THEMES[themeKey].name}
                    </span>
                    <div className="flex space-x-1">
                      <div
                        className="w-4 h-4 rounded-full border border-gray-400"
                        style={{ backgroundColor: THEMES[themeKey].primary }}
                      ></div>
                      <div
                        className="w-4 h-4 rounded-full border border-gray-400"
                        style={{ backgroundColor: THEMES[themeKey].secondary }}
                      ></div>
                      <div
                        className="w-4 h-4 rounded-full border border-gray-400"
                        style={{ backgroundColor: THEMES[themeKey].bg }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* SHARED PLAYER DETAIL MODAL */}
        {selectedPlayer && (
          <div className="fixed inset-0 bg-black/80 z-[100] flex items-center justify-center p-4">
            <div className="bg-theme-bg-alt border-4 border-theme-primary w-full max-w-sm shadow-[8px_8px_0_0_var(--c-secondary)] relative animate-in zoom-in-95 duration-200 flex flex-col max-h-[90vh]">
              <div
                className="absolute top-2 right-2 bg-theme-card border-2 border-theme-primary p-1 cursor-pointer hover:bg-theme-secondary hover:text-white transition-colors z-20"
                onClick={() => setSelectedPlayer(null)}
              >
                <X size={16} />
              </div>

              <div className="bg-theme-primary p-4 border-b-4 border-theme-secondary flex items-center flex-shrink-0">
                <div className="w-12 h-12 bg-theme-bg border-2 border-theme-secondary flex items-center justify-center rounded-full mr-4 flex-shrink-0 shadow-[2px_2px_0_0_var(--c-secondary)]">
                  <span className="text-theme-primary font-mono font-black text-xl">
                    {selectedPlayer.num}
                  </span>
                </div>
                <div>
                  <span className="text-theme-secondary font-sans text-[10px] font-bold tracking-widest uppercase">
                    {selectedPlayer.pos}
                  </span>
                  <h2 className="text-2xl font-black font-theme-head text-white uppercase leading-none mt-0.5">
                    {selectedPlayer.name}
                  </h2>
                </div>
              </div>

              <div className="flex justify-between items-center bg-theme-bg-alt px-4 py-2 text-theme-primary border-b-2 border-theme-primary shadow-sm text-[9px] font-sans font-black tracking-widest uppercase">
                <span>
                  B/T:{" "}
                  <span className="font-mono text-theme-text">
                    {selectedPlayer.bats}/{selectedPlayer.throws}
                  </span>
                </span>
                <span>
                  HT:{" "}
                  <span className="font-mono text-theme-text">
                    {selectedPlayer.height}
                  </span>
                </span>
                <span>
                  WT:{" "}
                  <span className="font-mono text-theme-text">
                    {selectedPlayer.weight}
                  </span>
                </span>
                <span>
                  AGE:{" "}
                  <span className="font-mono text-theme-text">
                    {selectedPlayer.age}
                  </span>
                </span>
              </div>

              <div
                className="p-5 bg-theme-card flex-1 overflow-y-auto"
                style={{ scrollbarWidth: "none" }}
              >
                <div className="border-2 border-theme-primary bg-theme-bg-alt p-3 mb-5 shadow-[2px_2px_0_0_var(--c-border-primary)]">
                  <div className="mb-2">
                    <span className="text-[9px] font-sans font-black text-theme-muted tracking-widest uppercase block mb-0.5">
                      Hometown
                    </span>
                    <span className="font-bold font-sans text-theme-primary uppercase tracking-wide">
                      {selectedPlayer.hometown}
                    </span>
                  </div>
                  <div className="mb-2">
                    <span className="text-[9px] font-sans font-black text-theme-muted tracking-widest uppercase block mb-0.5">
                      Contract
                    </span>
                    <span className="font-bold font-sans text-theme-primary uppercase tracking-wide bg-theme-secondary bg-opacity-10 px-1 border border-theme-secondary border-opacity-30">
                      {selectedPlayer.contract}
                    </span>
                  </div>
                  <div>
                    <span className="text-[9px] font-sans font-black text-theme-muted tracking-widest uppercase block mb-0.5">
                      Walk-Up
                    </span>
                    <div className="flex items-center font-sans text-theme-primary font-bold text-xs uppercase">
                      <Music
                        size={12}
                        className="text-theme-secondary mr-1.5 flex-shrink-0"
                      />
                      <span className="truncate">
                        {selectedPlayer.walkUp || "Not Available"}
                      </span>
                    </div>
                  </div>
                </div>

                <h3
                  className={
                    labelStyle + " mb-2 border-b-2 border-theme-secondary pb-1"
                  }
                >
                  2026 Primary Stats
                </h3>
                {String(selectedPlayer.pos).includes("P") ? (
                  <>
                    <div className="grid grid-cols-4 gap-2 mb-2">
                      <StatBox label="ERA" value={selectedPlayer.era} />
                      <StatBox label="WHIP" value={selectedPlayer.whip} />
                      <StatBox
                        label="W-L"
                        value={`${selectedPlayer.w}-${selectedPlayer.l}`}
                      />
                      <StatBox label="SO" value={selectedPlayer.so} />
                      <StatBox label="IP" value={selectedPlayer.ip} />
                      <StatBox label="SV" value={selectedPlayer.sv} />
                      <StatBox label="BB" value={selectedPlayer.bb} />
                      <StatBox label="HR" value={selectedPlayer.hrAllowed} />
                    </div>

                    <h3
                      className={
                        labelStyle +
                        " mt-4 mb-2 border-b-2 border-theme-secondary pb-1"
                      }
                    >
                      Extended Stats
                    </h3>
                    <div className="grid grid-cols-4 gap-2 mb-4 opacity-90">
                      <StatBox label="G" value={selectedPlayer.g} />
                      <StatBox label="GS" value={selectedPlayer.gs} />
                      <StatBox label="CG" value={selectedPlayer.cg} />
                      <StatBox label="SHO" value={selectedPlayer.sho} />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="grid grid-cols-4 gap-2 mb-2">
                      <StatBox label="AVG" value={selectedPlayer.avg} />
                      <StatBox label="OPS" value={selectedPlayer.ops} />
                      <StatBox label="HR" value={selectedPlayer.hr} />
                      <StatBox label="RBI" value={selectedPlayer.rbi} />
                      <StatBox label="H" value={selectedPlayer.hits} />
                      <StatBox label="2B" value={selectedPlayer.doubles} />
                      <StatBox label="3B" value={selectedPlayer.triples} />
                      <StatBox label="SB" value={selectedPlayer.sb} />
                    </div>

                    <h3
                      className={
                        labelStyle +
                        " mt-4 mb-2 border-b-2 border-theme-secondary pb-1"
                      }
                    >
                      Extended Stats
                    </h3>
                    <div className="grid grid-cols-4 gap-2 mb-4 opacity-90">
                      <StatBox label="G" value={selectedPlayer.g} />
                      <StatBox label="AB" value={selectedPlayer.ab} />
                      <StatBox label="OBP" value={selectedPlayer.obp} />
                      <StatBox label="SLG" value={selectedPlayer.slg} />
                    </div>
                  </>
                )}

                <h3
                  className={
                    labelStyle +
                    " mt-4 mb-2 border-b-2 border-theme-secondary pb-1"
                  }
                >
                  Recent Highlights
                </h3>
                {isLoadingPlayer ? (
                  <div className="text-center py-4 animate-pulse text-[10px] font-bold text-theme-primary uppercase tracking-widest">
                    Searching Archives...
                  </div>
                ) : playerHighlights.length > 0 ? (
                  <div
                    className="flex overflow-x-auto space-x-3 pb-2"
                    style={{ scrollbarWidth: "none" }}
                  >
                    {playerHighlights.map((hl: any, idx: number) => (
                      <div
                        key={hl.id}
                        className="w-36 flex-shrink-0 cursor-pointer group"
                        onClick={() => {
                          setSelectedPlayer(null); // Optional: close player modal when opening video
                          setActiveMedia({
                            type: "video",
                            title: hl.title,
                            source: selectedPlayer.name,
                            videoUrl: hl.videoUrl,
                            feed: playerHighlights.map((h: any) => ({
                              type: "video",
                              title: h.title,
                              source: selectedPlayer.name,
                              videoUrl: h.videoUrl,
                            })),
                            index: idx,
                          });
                        }}
                      >
                        <div className="relative border-y-[4px] border-x-2 border-dotted border-[#1A1A1A] bg-[#1A1A1A] h-20 flex items-center justify-center shadow-[2px_2px_0_0_var(--c-border-primary)] transition-transform group-active:translate-y-1 group-active:shadow-none overflow-hidden">
                          <div className="absolute inset-1 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gray-700 to-gray-900 border border-gray-600 z-0"></div>
                          <Play
                            className="text-white relative z-10 opacity-80 group-hover:opacity-100 group-hover:scale-110 transition-all"
                            size={24}
                            fill="currentColor"
                          />
                        </div>
                        <p className="text-[9px] font-bold font-theme-head text-theme-primary leading-tight mt-1.5 line-clamp-2">
                          {hl.title}
                        </p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-4 text-[10px] font-bold text-theme-muted uppercase tracking-widest bg-theme-bg border-2 border-dashed border-theme-primary/30">
                    No Recent Highlights Found
                  </div>
                )}

                <button
                  onClick={() => setSelectedPlayer(null)}
                  className="w-full mt-4 bg-theme-primary text-white font-sans py-2 text-xs font-black uppercase tracking-widest border-2 border-theme-secondary shadow-[2px_2px_0_0_var(--c-secondary)] active:translate-y-[2px] active:shadow-none"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {activeMedia && (
          <div className="fixed inset-0 bg-black/90 z-[100] flex items-center justify-center p-2 sm:p-4 pt-10">
            <div className="bg-theme-bg-alt w-full max-w-md h-[90vh] sm:h-[85vh] border-4 border-theme-primary shadow-[8px_8px_0_0_var(--c-secondary)] flex flex-col relative animate-in zoom-in-95 duration-200">
              <div className="bg-theme-primary p-3 flex justify-between items-center border-b-4 border-theme-secondary flex-shrink-0">
                <div className="flex items-center truncate pr-4">
                  {activeMedia.type === "video" ? (
                    <Youtube
                      size={16}
                      className="text-theme-secondary mr-2 flex-shrink-0"
                    />
                  ) : (
                    <Newspaper
                      size={16}
                      className="text-theme-secondary mr-2 flex-shrink-0"
                    />
                  )}
                  <span className="text-white font-bold font-theme-head text-sm truncate uppercase tracking-widest">
                    {activeMedia.source || "Media Viewer"}
                  </span>
                </div>
                <button
                  onClick={() => setActiveMedia(null)}
                  className="bg-theme-card text-theme-primary border-2 border-theme-primary hover:bg-theme-secondary hover:text-white p-1 transition-colors flex-shrink-0 shadow-[2px_2px_0_0_var(--c-secondary)]"
                >
                  <X size={16} />
                </button>
              </div>

              <div className="flex-1 bg-theme-bg flex flex-col relative overflow-hidden">
                {activeMedia.type === "video" ? (
                  <div className="w-full h-full bg-black flex flex-col">
                    <div className="p-3 bg-theme-bg-alt border-b-2 border-theme-primary text-theme-primary text-xs font-bold font-theme-head truncate">
                      {activeMedia.title}
                    </div>
                    <div className="flex-1 flex items-center justify-center w-full relative bg-black">
                      <video
                        key={activeMedia.videoUrl}
                        controls
                        autoPlay
                        className="w-full aspect-video border-y-4 border-theme-primary bg-black"
                        src={activeMedia.videoUrl}
                      >
                        Your browser does not support HTML5 video streaming.
                      </video>
                    </div>
                    {activeMedia.feed && activeMedia.feed.length > 1 && (
                      <div className="bg-theme-bg-alt border-t-2 border-theme-primary p-3 flex justify-between items-center flex-shrink-0">
                        <button
                          onClick={() =>
                            activeMedia.index > 0 &&
                            setActiveMedia({
                              ...activeMedia.feed[activeMedia.index - 1],
                              feed: activeMedia.feed,
                              index: activeMedia.index - 1,
                            })
                          }
                          disabled={activeMedia.index === 0}
                          className={`flex items-center space-x-1 font-bold text-xs uppercase tracking-widest transition-colors ${
                            activeMedia.index === 0
                              ? "text-gray-500 cursor-not-allowed"
                              : "text-theme-primary hover:text-theme-secondary"
                          }`}
                        >
                          <ChevronLeft size={16} /> <span>Prev</span>
                        </button>
                        <span className="text-[10px] text-theme-muted font-bold tracking-widest uppercase">
                          {activeMedia.index + 1} of {activeMedia.feed.length}
                        </span>
                        <button
                          onClick={() =>
                            activeMedia.index < activeMedia.feed.length - 1 &&
                            setActiveMedia({
                              ...activeMedia.feed[activeMedia.index + 1],
                              feed: activeMedia.feed,
                              index: activeMedia.index + 1,
                            })
                          }
                          disabled={
                            activeMedia.index === activeMedia.feed.length - 1
                          }
                          className={`flex items-center space-x-1 font-bold text-xs uppercase tracking-widest transition-colors ${
                            activeMedia.index === activeMedia.feed.length - 1
                              ? "text-gray-500 cursor-not-allowed"
                              : "text-theme-primary hover:text-theme-secondary"
                          }`}
                        >
                          <span>Next</span> <ChevronRight size={16} />
                        </button>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="w-full h-full flex flex-col bg-theme-card">
                    <div className="p-2 border-b-2 border-theme-primary bg-theme-bg-alt flex justify-between items-center z-10 shadow-sm flex-shrink-0">
                      <span className="text-[10px] font-bold text-theme-muted uppercase tracking-widest truncate mr-2 max-w-[65%]">
                        {activeMedia.title}
                      </span>
                      {activeMedia.link && activeMedia.link !== "#" && (
                        <a
                          href={activeMedia.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-[9px] font-black text-white bg-theme-secondary px-2 py-1 border-2 border-theme-primary whitespace-nowrap shadow-[1px_1px_0_0_var(--c-primary)] active:translate-y-[1px] active:shadow-none transition-all"
                        >
                          Open Web
                        </a>
                      )}
                    </div>
                    <div className="flex-1 overflow-y-auto p-5 bg-theme-card">
                      {activeMedia.content ? (
                        <div
                          className="article-content"
                          dangerouslySetInnerHTML={{
                            __html: activeMedia.content,
                          }}
                        />
                      ) : (
                        <div className="flex flex-col items-center justify-center h-full text-center text-theme-muted">
                          <Newspaper size={48} className="mb-4 opacity-20" />
                          <p className="font-bold uppercase tracking-widest text-xs">
                            Content unavailable.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
